var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvtarr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M0 0L0 512L9 510L9 509C5.50592 502.189 4.41738 480.848 10 475C4.10188 468.753 7 454.199 7 446L13 447L7 445C7 436.565 3.83188 419.822 9 413L9 412L9 411C4.64569 405.253 7 393.029 7 386L7 322L7 156C7 126.757 4.33462 96.0028 8 67L13 67C14.1541 51.7024 31.6338 57.1502 41.0147 58.1705C44.0871 58.5047 46.9304 56.3365 50 56.1265C55.3872 55.758 61.5725 57.7873 67 58.3125C71.5636 58.7541 76.4267 53.6785 80.7716 56.0679C86.1993 59.0527 82.6638 67.7537 87 72C88.4756 67.4782 87.3469 58.4436 93 57L92 55L93 55L123 53.6883L132 55.7137L159 52L159 56L155 56L157 70C153.195 70.8221 152.025 72.2864 151 76L153 76C147.298 85.6169 151.541 97.5991 163 101L162 107L170 108L169 112L173 111C174.48 118.142 183.139 123.972 181.476 131.981C179.539 141.31 166.45 134.655 161.607 139.603C157.483 143.818 166.269 159.343 167 165L176 160C184.323 181.228 216.953 141.073 224 161L227 160L225 165L216 169L217 174L216 174L214 172C209.442 177.181 204.648 177.995 198 178L199 176C182.407 178.207 185.458 192.333 182 204C179.603 202.15 175.269 199.986 174.33 196.907C172.811 191.921 181.738 172.011 168 174L168 176C173.618 182.444 145.61 189.815 166 190C162.122 198.31 164.481 207.207 175 208C172.189 211.367 167.543 217.086 172.703 220.971C174.912 222.635 186.548 221.211 182.914 227.597C179.533 233.536 167.861 238.844 162 242.154C149.532 249.194 138.763 255.836 130.62 268C122.738 279.774 124.221 297.754 119.34 311C102.914 355.576 90.5489 400.037 93.9105 448C94.826 461.062 98.0348 472.464 101.572 485C102.959 489.916 103.247 495.745 106.51 499.896C121.36 518.791 152.535 512 174 512L358 512L412 512C417.688 512 427.345 514.067 431 509L442 508L449 512L448 509L445 510L448 494L449 505L452 504L454 512L455 512L455 502L454 508L456 512L470 512C468.135 503.058 470.043 493.696 459 494C460.531 500.496 463.336 504.949 459 511L460 500C453.766 499.289 455.723 491.698 456 487L460 492L469 491L473 492L465 489L465 488L468 487L465 482L467 484L468 484L467 475L474 483L474 467L477 466L477 465L474 466L474 461L473 461L470 464L471 469L469 466L465 464L469 465L469 462L468 462L465 462L468 455L470 458L473 457L473 454L471 449L467 443L473 450L471 443L475 442L475 447L481 451L475 450L476 460L483 460L487 452L485 448C488.332 448.638 489.842 448.294 491 445L485 444L485 447L484 447L476 442L484 445L480 438C474.439 438.219 469.322 438.661 467 433L480 425L477 421L478 424L474 423L475 418L472 417L472 416L475 416L476 410L469 405L469 404L471 403L469 401L474 401L472 392L476 393L476 392L471 391L477 386L481 389L482 388L481 380L475 380L476 376L470 376L469 372L472 369L474 370L475 370L474 367L477 363L476 363L475 363L473 366L474 364C460.968 364 480.185 345.969 469 342L469 341L470 337L474 336L472 334L476 321L479 330L475 329L475 333L478 334L476 336L478 343L473 342L475 348L477 346L482 345L482 341C479.675 337.513 482.861 326.465 485 327L483 315L478 315L477 320L477 316L475 319L478 313L478 312L474 306L478 295C475.504 293.336 473.594 291.149 477 292L476 287L480 286L480 251L482 251L483 258L485 258L486 255L489 257L487 251L491 251L489 254L492 259L491 259L491 257L490 257L494 262L493 248L489 250C488.366 245.003 488.646 238.85 484 236L489 211L489 196L490 196L493 197L493 206L494 206L495 197L499 195L500 195C500.019 197.132 500.322 199.529 499.592 201.577C497.14 208.448 486.594 239.755 505 232L495 267L496 262L499 272L495 272L495 284L491 284L490 292L498 295L491 297L494 309L493 312L491 323L490 320L487 320L488 324L493 324L489 342L492 352L493 352L497 335L494 337L493 337C495.114 332.365 500.218 329.255 505 332L502 332L502 334L504 333L505 333L505 355L502 353L498 363L501 362L501 368L503 368L504 365L505 365L504 422L501 420C503.137 425.21 505.936 429.614 503 435L503 440L503 441L505 474C500.281 474.603 503.797 480.009 505 483L501 485L501 486L505 486L505 512L512 512L512 0L252 0.0393677L7 18L7 7L82 1L57 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M82 0L82 1L93 1L82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M93 0L93 1L104 1L93 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M7 8L7 16L112 10C114.763 4.73969 119.304 4.67212 122 10L132 5C133.965 10.9002 143.779 8.02643 149 7.99924C166.535 7.9079 184.493 1.45309 202 2L202 0L107 0.0895081L7 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M156 7L156 8C173.94 7.62769 192.103 2.65814 210 2.57175C215.991 2.54282 227.603 5.05762 232 0L156 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M223 0L223 1L229 1L223 0M232 0L233 1L232 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M233 0L233 1L243 1L233 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M232 1L232 2L248 1L232 1M436.667 0.333344L437.333 0.666656L436.667 0.333344M445.667 0.333344L446.333 0.666656L445.667 0.333344M78 1L78 2L81 2L78 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M81 1L81 2L90 2L81 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M63 2L63 3L73 3L63 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M73 2L73 3L80 3L73 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M202 3L202 4L221 4L202 3M223 2L224 3L223 2M225 2L225 3L232 3L225 2M501 2L501 4L503 4L503 2L501 2M49 3L49 4L56 4L49 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M56 3L56 4L64 4L56 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M438.333 3.66666L438.667 4.33334L438.333 3.66666M37 4L37 5L42 5L37 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M42 4L42 5L49 5L42 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M194 4L194 5L201 5L194 4M446 4L446 6L448 6L448 4L446 4M24 5L24 6L34 6L24 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M34 5L34 6L38 6L34 5M112 10L33 14L33 15L150 9L150 8C144.405 8 135.064 10.4207 132 5L122 10C120.192 4.04407 113.867 4.0889 112 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M190 5L190 6L194 6L190 5M420.667 5.33334L421.333 5.66666L420.667 5.33334M14 6L14 7L20 7L14 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M20 6L20 7L27 7L20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M166 6L166 7L181 7L166 6M462 6L462 8L464 8L462 6M7 7L8 8L7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M8 7L8 8L15 8L8 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M162 7L162 8L165 8L162 7M473 7L474 8L473 7M150 8L150 9L158 9L150 8M448 11L449 11L450 9L448 11M454 8L455 9L454 8M476 8L475 11L476 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M477 8L476 11L477 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M139 9L139 10L147 10L139 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M448 9L449 10L448 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M449 9L450 10L449 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M130 10L130 11L138 11L130 10M112 11L112 12L127 12L112 11M446 11L447 12L446 11M7 16L7 18L104 14L77 14L7 16M104 12L104 13L110 13L104 12M481 13L481 14L484 15L484 12L481 13M422 13L423 14L422 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M423 13L424 14L423 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M424 13L424 15L426 15L426 13L424 13M449 16L450 16L452 14L449 16M461 13L460 15L461 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M23 14L23 15L32 15L23 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420.333 14.6667L420.667 15.3333L420.333 14.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M445 14L444 18L451 18L451 17L446 17L445 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M446 14L446 17L447 17L446 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M450 14L450 15L457 16L457 15L450 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456 14L458 16L458 14L456 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M461.667 14.3333L462.333 14.6667L461.667 14.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 14L475 16L477 16L475 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M476 14L477 15L476 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M480.667 14.3333L481.333 14.6667L480.667 14.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M482 14L483 15L482 14M8 15L9 16L8 15M11 15L11 16L23 16L11 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M445 15L446 16L445 15M449 17L452 15L449 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M408 16L408 17L411 17L408 16M416 16L416 19L418 19L418 16L416 16M456 16L457 17L456 16M439 17L440 18L439 17M443 17L444 18L443 17M451 17L452 18L451 17M365.667 18.3333L366.333 18.6667L365.667 18.3333M432 18L432 20L434 18L432 18M384 22L390 21C387.431 19.548 385.849 19.646 384 22M244 25L244 26L251 25L250 28L266 28C262.264 22.071 249.794 22.571 244 25M308 25L308 26L313 27L313 26L309 26L309 25L312 25L308 25M215 31L224 28L224 29L221 30L221 31L229 29L229 28L227 28L227 27L243 28C236.22 24.7164 219.422 23.7717 215 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M309 25L309 26L314 26L309 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M314 25L315 26L314 25M490 25L490 26L493 26L490 25M304 26L304 27L307 27L304 26M488 26L485 28L485 30L491 30L488 26M499 26L495 34L496 34L501 26L499 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M224 27L225 28L224 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M227 27L227 28L230 28L227 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M270 27L268 32L287 38L286 41L289 45L292 43L299 52L294 52L291 49L300 56L300 57L295 57L295 58L301 58L297 60L298 63C302.003 61.5503 303.987 61.9614 307 65L302 63L309 73L310 73L308 69L318 69L318 70L315 74L311 73L311 74L320 80C315.403 89.1956 319.917 100.882 320 111L322 108L325 112L320 112L320 118L325 116L324 113L334 111L334 110L330 107L335 107L335 106L327 102L337 99L336 112L331 112L329 119L331 126L327 123L326 127L329 126L329 130L336 128L335 131L332 129L330 133L319 130L318 130L318 135L324 133L320 140L319 140L319 136L318 136C317.278 152.814 311.149 172.242 322 186L320 185L321 188L318 189L319 196C325.945 197.968 325.262 203.138 327 209L329 209L330 208L329 202L334 202L332 205L335 206L341 199L346 198L343 201L346 205L349 204L351 191L346 192L344 188L355 184L357 177L358 177L358 184L361 181L363 181L362 193L367 197L367 198L363 198L363 205L365 202L366 202L365 208L371 202L369 207L373 207L372 196L372 195L374 193L371 184L374 181L376 188L379 186L377 195L377 196L378 200L382 200C382 204.026 386.436 221 381 221L381 229L383 229L383 222C387.803 221.347 387.347 214.635 386 211L391 211L389 217L389 218L392 219L391 223L389 222L389 231L389 232L392 225L393 225L396 232L394 234L397 231L400 231L402 236L402 230C406.176 229.105 404.114 226.309 404 223L401 217L401 216L404 215L401 210L404 210C401.008 196.54 404.651 184.18 406 171C403.606 168.972 402.417 167.857 404 165L404 169L405 169C406.025 165.718 404.904 160.906 401 161L405 156L402 157L399 154L404 141L402 138C409.143 131.429 408.506 112.92 400 108L404 102L400 102L406 97L406 96L402 86L405 86L404 80L407 82L407 63L408 56C405.174 56 405.209 57.1416 405 60L404 60L401 55C401.67 50.4549 400.548 47.8871 397 45L395 52L392 53L394 56L390 56C390.37 61.6341 392.676 65.5449 388 70L390 67L387 68L385 52L384 52L381 55L383 62L382 62L379 59L379 56L373 57L375 55L375 54L373 47L375 46L376 48L377 48L371 43L368 60C365.956 55.7613 366.526 53.1713 370 50C365.421 44.5236 361.109 47.9582 354.996 47.9244C346.203 47.8757 336.19 42.751 328 47L327 44L320 48L317 45L316 49L302 43L301 48C293.527 44.929 295.894 40.6662 291.157 35.7377C286.083 30.4597 277.11 27.2838 270 27M257 28L257 29L265 33L257 28M208 32L212 33L213 30L208 32M228 31L228 32L236 30L228 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M272 29L273 30L272 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487.667 29.3333L488.333 29.6667L487.667 29.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 30L504 31L503 30M218.667 31.3333L219.333 31.6667L218.667 31.3333M221.667 32.3333L222.333 32.6667L221.667 32.3333M444.667 32.3333L445.333 32.6667L444.667 32.3333M449 32L450 33L449 32M452 32L452 34L454 34L454 32L452 32M489 32L490 33L489 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M495 32L496 33L495 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M494.333 33.6667L494.667 34.3333L494.333 33.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M447.667 34.3333L448.333 34.6667L447.667 34.3333M455 34L454 40L455 40L455 35L456 35L456 40L457 40L457 34L455 34M459 36L459 39L463 38L464 34L459 36M493 34L492 36L492 37C494.158 36.0224 494.501 35.8117 493 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M455 35L455 40L456 40L455 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M493 35L494 36L493 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M204 36L204 37L208 37L204 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M458 36L458 38L460 38L458 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M462 36L463 37L462 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M487 37L488 45L489 45L490 40L493 39L487 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 37L493 38L492 37M288.667 38.3333L289.333 38.6667L288.667 38.3333M486 41L490 40L488 38L486 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M282 39L282 41L284 39L282 39M437 39L437 47L442 47L442 46L442 45L440 46L442 44L442 43L437 39M443 39L443 47L447 43L447 42L443 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M289 40L290 41L289 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M490 40L491 41L490 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M425 41L426 42L425 41M429 42L429 43L433 44L432 41L429 42M448 42L448 43L453 42L453 43L448 44L447 44L448 47L451 45L452 47L453 46L451 45L451 44L455 43L457 51C459.554 44.7505 453.825 40.5926 448 42M398 42L401 44L401 43L398 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M448 43L448 46L452 42L448 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M452 42L453 43L452 42M488.333 42.6667L488.667 43.3333L488.333 42.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M291 43L290 49L294 52L299 52L291 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M438 43L439 44L438 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M453 43C452.392 47.642 453.32 50.0741 457 53C456.983 48.8283 456.881 45.242 453 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M170 44L173 51L175 51L175 46L173 48L170 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M171 44L174 48L171 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M172 44L173 45L172 44M367 44L368 45L367 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M448 44L449 45L448 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M451.667 44.3333L452.333 44.6667L451.667 44.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M172 45L173 46L172 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M403 45L404 55L405 55L409 51L411 49L411 48L407 49L409 45L403 45M422 45L422 49L423 49L424 45L422 45M427 47L430 46L427 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M443 45L444 46L443 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486 45L485 50L486 50L486 45M182 46L187 51L182 46M201 48L201 49L215 48C210.951 44.9482 205.556 46.5592 201 48M352 46L353 47L352 46M287 47L288 48L287 47M289 47L288 49L290 49L289 47M430 47L431 48L430 47M216 48L216 49L219 49L216 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M321 48L321 54L322 54L321 48M360 53L358 53L355 49L359 56C363.095 54.433 364.021 52.2019 363 48L360 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452.333 48.6667L452.667 49.3333L452.333 48.6667M465 48L466 49L465 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M484 48L485 49L484 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492.333 48.6667L492.667 49.3333L492.333 48.6667M198 55L198 56L210 55L210 54L201 54L201 53L219 52C211.991 42.654 198.756 54.811 198 55M228 51L234 50L228 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M305 49L309 54C308.862 50.7974 308.06 49.9594 305 49M365 49L366 50L365 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 49L484 50L483 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 49L482 53L483 53L484 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M170 50L173 54L175 58L176 55L170 50M189 50L189 51L192 51L189 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M333 50L332 52L334 52L333 50M397 50L398 51L397 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M426 50L427 51L426 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M482 50L483 51L482 50M484 50L485 51L484 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M92 55L93 57C87.2287 58.2303 88.1446 67.2058 87 72C84.0065 67.8384 85.5317 57.6099 80.7716 55.618C76.1638 53.6898 71.6327 58.2562 67 57.919C58.5846 57.3065 48.8842 58.5316 41 57.5903C31.3564 56.4388 13.4855 52.0494 13 67L8 67L7 126L8 126L8 122L9 122L14 146C9.57853 148.499 10.91 152.471 11 157L16 156L13 153L17 146L15 147L16 144L14 144C20.7216 126.052 14.1205 107.021 14.9606 89C15.1609 84.7037 15.6534 70.419 23 74C44.1811 71.066 32.5722 91.9275 44 100L47 74C53.2325 77.5311 56.443 79.5442 58 87L60 87L65 74C66.0447 91.8918 67.6943 110.172 67.1613 128C67.0307 132.366 63.5425 144.675 66.3758 147.642C69.5122 150.927 75.8763 147.52 72 144L77 134C67.7661 128.742 72.1659 112.679 71.571 104C71.1713 98.1692 68.8401 93.0345 69.814 87C70.4188 83.253 72.7263 71.4598 78 74L81 73C85.1369 88.8209 84.3069 96.7283 79.7639 112C78.494 116.269 81.0079 118.946 77 122L77 125C80.8538 125.278 96.3111 125.753 87 120L93 114C91.3861 100.568 88.4344 87.3885 93.4954 74.1844C95.6599 68.5371 106.663 65.8824 110.442 71.2377C112.8 74.5778 113.157 79.3288 115 83L116 83C119.25 74.3233 119.153 66.8693 129 63C133.503 69.8641 146.28 58.0788 153 58L153 69L148 70L147.458 87L156 106L156 107L164 108L166 118C169.535 120.173 170.932 121.789 171 126L176 133L171 133L173 128C167.436 129.452 157.791 135.394 157.578 142.001C157.446 146.1 160.813 149.725 161 154C167.725 160.728 160.201 170.992 158.258 178.985C157.095 183.774 153.381 186.907 159 190L159 189C155.448 182.714 177.49 182.838 168 176L168 174C181.869 174.605 172.228 190.754 173.748 196.907C174.608 200.391 179.165 202.418 182 204C186.798 192.403 182.334 179.916 199 176L198 178C204.37 177.999 210.39 177.994 214 172L216 174L217 174L216 169L225 165L227 160L224 161C221.67 151.423 216.154 155.565 209 157.818C198.345 161.174 183.112 172.158 176 160L167 165C166.469 158.324 159.414 147.979 160.816 142.059C162.59 134.572 175.806 139.992 180.258 135.397C186.893 128.55 175.116 117.157 173 111L169 112L170 108L162 107L163 101C151.768 95.506 148.585 86.7442 153 76L151 76L157 70L155 56L159 56L159 52L132.285 55.3055L123.999 53.3943L92 55M163 51L163 52L166 52L163 51M194.667 51.3333L195.333 51.6667L194.667 51.3333M274 52L277 55L276 53L277 53L281 58L282 58L284 53L279 51L280 54L274 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M302 51L302 54L304 51L302 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M439.667 51.3333L440.333 51.6667L439.667 51.3333M454 51L455 52L454 51M481 51L480 56L481 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M483 51L484 52L483 51M299 52L300 53L299 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M323 58L326 54L327 54L328 56L329 52L323 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M354 52L353 53L353 54L354 55L355 55L356 54L356 53L354 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M455 52L456 53L455 52M457 52L458 53L457 52M483 52L484 53L483 52M192.667 53.3333L193.333 53.6667L192.667 53.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M276 53L280 56L276 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M285 53L284 56L284 57L294 56L294 55C290.81 53.8773 289.87 54.1585 288 57L285 53M360 53L361 54L360 53M386 55L389 55L388 53L386 55M456 53L457 54L456 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M172 54L173 55L172 54M287 54L289 57L289 54L287 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M311 54L312 55L311 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M334 54L332 57L335 58L336 57L334 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M435 54L435 56L437 56L437 54L435 54M439 54L440 55L439 54M444 54L443 55L446 57L444 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M173 55L174 56L173 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M211 55L211 56L214 57L211 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M289 59L291 61L292 61L298 66C299.41 60.842 292.871 52.2474 289 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M306 55L303 56L304 59L308 55L306 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M344 55L345 56L344 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M346 58L352 61L353 56C349.828 55.2258 347.915 55.2177 346 58M396 55L396 56L399 57L396 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M297 56L298 57L297 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M298.667 56.3333L299.333 56.6667L298.667 56.3333M354 56L355 57L354 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M438 56L439 57L438 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M310 59L314 58L310 59M328 57L329 58L328 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M362 57L362 59L364 57L362 57M370 57L370 58L373 58L370 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M449 57L447 60L448 67L450 64L449 70L450 70L453 67L449 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M129 63C118.827 65.6713 118.448 74.2876 116 83L115 83C113.618 79.2915 113.009 73.3121 110.272 70.4074C106.281 66.1702 95.6628 67.9728 93.4954 73.3256C88.4119 85.8803 90.0748 101.152 93 114L87 120C93.3958 126.2 81.3916 125.089 77 125L77 122C81.4501 119.406 78.7593 116.208 80.2176 112C85.1372 97.8035 86.0598 87.59 81 73L78 74C73.9687 68.4823 70.2376 83.3036 69.6667 85.9954C68.3261 92.3157 70.7443 97.847 71.3472 104C71.9633 110.287 70.9157 116.617 71.7407 123C72.3386 127.626 71.7127 132.541 77 134L72 144C74.2164 147.938 69.1225 150.273 66.6165 146.758C64.0483 143.155 67.406 130.646 67.5008 126C67.8436 109.188 67.0004 90.8437 65 74C61.012 76.8408 60.2405 82.3044 60 87L58 87C57.0454 79.2154 53.7642 76.9484 47 74L44 100C35.3533 90.7736 42.3449 69.2705 23 74C16.8349 67.5448 15.1062 84.9034 14.9606 88C14.0765 106.811 19.3642 124.911 14 144L16 144L15 147L17 146L17 147L13 153L16 156L11 157L14 146L9 122L8 122C5.43282 142.313 7 163.524 7 184C7 190.589 4.86587 200.825 11 205C5.28393 211.032 7 222.221 7 230C7 252.088 5.23285 275.104 8 297L15 298C3.14767 300.989 6.79124 310.157 14 317L8 315L7 377L7.3179 405.776L13 414C3.61387 414.731 5.90624 435.917 8 443C13.6884 442.791 14.4776 445.93 14 451L17 452L13 454L13 455L18 454L19 455L19 457L18 458C10.0494 456.108 7.02906 457.778 7 466L14 464L8 470L13 477L8 477L7 483L12 484L8 493L11 500L10 497L17 497L16 491C21.4891 489.912 23.8063 488.9 24 483L36 487L39 484L39 483L27 481L28 475C37.5131 477.713 38.2489 475.477 47 473L52 469C50.5 472.185 44.0725 476.127 47 479L47 480L42 483L48 483L47 486L53 490L53 491L46 493L46 494L48 495L48 496L31 502L32 504L31 504L23 502C17.7677 505.764 11.5876 504.297 11 512L19 509L21 509C24.6993 514.129 32.401 510.875 38 512C36.986 502.102 45.8625 502.063 54 501.083C56.8657 500.738 62.4471 502.317 63 499L67 500L71 495L62 494L59 496L54 491L56 487L51 486L51 485L54 482L49 484L56 469L47 466L47 464L50 463L46 457L59 458C60.4164 462.997 65.0115 460.709 63 456L70 458C70 454.969 74.3306 454.605 77 455L73 457L73 458L78 458L79 452L72 452L72 451L77 449L77 448L71 448L75 443C69.6551 444.662 67.1552 449.797 66 455L64 455L66 450L66 449L65 447L54 448L48 437L53 436L53 438L79 434L78 437L81 437L80 434C95.3562 433.958 91.7811 422.241 92 410L91 410L83 415L83 416L88 416L89 417L88 420L84 423L86 426L79 428L80 431L77 431L78 428L74 427L74 426L82 425L82 424L76 423L76 421L82 418L76 419L71 413L80 412L78 416L82 417L79 410L81 406L85 406L85 409L93 409C94.4541 375.134 108.08 342.331 118.752 311C123.03 298.439 122.063 282.551 128.443 271C134.941 259.235 144.806 251.901 156 245.2C163.799 240.531 172.879 238.239 173 228L177 227L177 225C171.372 222.109 166.113 215.224 172 210L172 209C163.858 205.377 161.118 198.734 165 191C143.016 189.005 173.828 162.73 161 154C161.496 149.37 157.842 146.297 158.063 142.001C158.381 135.837 167.968 129.974 173 128L171 133L176 133L171 126C171.578 121.491 170.12 119.712 166 118L164 108L156 107L156 106C160.312 100.011 148.493 92.6545 147.593 86C146.766 79.8822 150.982 76.2419 148 70L153 69L153 58C145.435 58.0268 134.894 68.635 129 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M297 58L298 61L301 58L297 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M408 58L409 59L408 58M457 58L455 62L458 63L459 60L457 61L457 58M290 59L293 64L293 59L292 59L290 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M323 60L324 64L328 64L327 69C330.875 67.8988 329.933 65.4839 330 62L329 60L323 60M365 59L366 60L365 59M371 59L374 62L371 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M377 59L376 68L377 68L377 64L380 65L379 59L377 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M442 59L442 63L443 63L444 59L442 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M457.333 59.6667L457.667 60.3333L457.333 59.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M458 59L459 60L458 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 59L497 60L496 59M256 60L257 61L256 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M313 60L309 63L309 65L314 66L313 60M340 60L340 61L343 65L350 66L350 67L347 68L349 72L344 70C342.601 74.9111 343.149 78.4974 349 78L344 82L350 86L350 85L347 82L353 86L351 85L351 86L354 89L353 86L356 86L350 77L356 77L356 76L351 73L350 68L353 62L343 63L345 60L340 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M403 60L404 61L403 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M160 61L161 62L160 61M295.333 61.6667L295.667 62.3333L295.333 61.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M300 61L301 64L304 64L304 61L300 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M337.667 61.3333L338.333 61.6667L337.667 61.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M361 61L363 64L361 61M366 61L367 62L366 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M396 61L400 64L400 63L396 61M456 61L457 62L456 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 61L494 63L496 63L496 61L494 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M299.333 62.6667L299.667 63.3333L299.333 62.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M303 62L306 65L303 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M304 62L306 64L306 62L304 62M332 62C332 64.988 333.253 64.8289 336 64L336 63L332 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M455 62L455 64L457 64L457 62L455 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M490 62L490 64L492 64L490 62M204 63L205 64L204 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M205 63L206 64L205 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M206.667 63.3333L207.333 63.6667L206.667 63.3333M235.667 63.3333L236.333 63.6667L235.667 63.3333M265 63L265 64L269 65L265 63M300 63L301 64L300 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M357 63L355 65L356 69L359 63L357 63M371.667 63.3333L372.333 63.6667L371.667 63.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M457 63L458 64L457 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M217 64L219 66L219 64L217 64M231 64L231 65L234 65L231 64M299 64L295 65L303 69L303 74L304 74C304.911 69.2695 303.101 66.3721 299 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M306 64L307 65L306 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M349 64L350 65L349 64M433 64L434 65L433 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M434 64L435 65L434 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M448 64L448 67L445 68L448 69L446 74L447 74L449 71L450 64L448 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456 64L457 65L456 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M338 65L339 66L338 65M365 65L365 66L369 66L365 65M394.333 65.6667L394.667 66.3333L394.333 65.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M464.333 65.6667L464.667 66.3333L464.333 65.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M465 65L466 66L465 65M222 70L228 67C224.863 65.9987 223.513 67.2439 222 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M300 66L302 68L302 66L300 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M363.333 66.6667L363.667 67.3333L363.333 66.6667M396 66L395 68L397 68L396 66M398 66L399 67L398 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M440 66L441 67L440 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M311 67C310.451 70.8154 311.595 72.2811 315 74L318 70L311 67M373 67L372 69L374 69L373 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M392 67L393 68L392 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M445 67L446 68L445 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 67L492 68L491 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M368 68L369 69L368 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M370.333 68.6667L370.667 69.3333L370.333 68.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M444 68L445 69L444 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M448 68L449 69L448 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M158.667 69.3333L159.333 69.6667L158.667 69.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M308 69L310 71L310 69L308 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M325 69L327 74L329 70L325 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M376 69L375 71L376 69M398 69L399 70L398 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M432 69L433 70L432 69M445 69L446 71L447 71L448 69L445 69M490.333 69.6667L490.667 70.3333L490.333 69.6667M252.667 70.3333L253.333 70.6667L252.667 70.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M303 70L304 71L303 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M322 80L321 77L326 77L325 74L319 76L322 71C314.845 70.3841 318.373 77.6408 322 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M366.667 70.3333L367.333 70.6667L366.667 70.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M310 71L310 73L312 73L310 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M363 71L364 72L363 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M370 71L371 72L370 71M400.333 71.6667L400.667 72.3333L400.333 71.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M447.333 71.6667L447.667 72.3333L447.333 71.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 71L449 72L448 71M193 72L195 74L195 72L193 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M303 72L304 73L303 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M340 72L341 73L340 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M345 73L347 76L351 73L347 72L345 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M360 72L359 74L361 74L360 72M365 73L365 74L370 74L365 73M375 72L373 79C376.537 78.5622 376.434 75.2149 377 72L375 72M387 72L388 73L387 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M434.333 72.6667L434.667 73.3333L434.333 72.6667M445.333 72.6667L445.667 73.3333L445.333 72.6667M472 72L473 73L472 72M306 73L307 74L306 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M356 73L358 75L358 73L356 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M447 73L447 76L448 76L449 73L447 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M334.667 74.3333L335.333 74.6667L334.667 74.3333M362.667 74.3333L363.333 74.6667L362.667 74.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M439 76L442 76L438 81L439 86L435 83L434 83L440 90L440 82L442 79L445 81L446 77L443 78L444 75L439 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M447 74L448 75L447 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M42 75L42 81L43 81L42 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M191 75L192 80L194 76L193 76L193 78L192 78L191 75M200 75L201 76L200 75M303.333 75.6667L303.667 76.3333L303.333 75.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M304 75L307 78L304 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M330 75L331 76L330 75M339 75L340 76L339 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M359 75L360 85L364 89L360 91L362 94L359 94L358 97L360 103L358 103L359 115L359 123L362 122L358 124L358 125L360 129L357 129L361 135L359 131L363 132L363 120L366 119L362 116L367 111L365 99L361 95L366 97L368 92L364 92L364 91L370 91L366 76L362 80L361 80L361 75L359 75M401 75L402 76L401 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M440 75L441 76L440 75M192.333 76.6667L192.667 77.3333L192.333 76.6667M443 76L444 77L443 76M473 76L474 77L473 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474 76L475 77L474 76M490 76L489 80L490 80L490 76M495 76L493 81L494 81L494 78L495 78L496 80L495 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M86 77L88 79L88 77L86 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M330 80L325 79L326 86L319 86L319 89L332 88L335 81L335 80L332 77L330 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M385 77L386 78L385 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M401 77L401 80L402 80L401 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M447 77L448 78L447 77M306 78L307 79L306 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M339 78L339 81L340 81L339 78M393.667 78.3333L394.333 78.6667L393.667 78.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477.667 78.3333L478.333 78.6667L477.667 78.3333M179 79L179 80L184 81L179 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M355 79L355 82L357 82L357 79L355 79M381 79L381 83L385 79L381 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 79L500 81L502 81L500 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M501 79L502 80L501 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M341 80L342 82L343 82L344 80L341 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487 80L489 82L489 80L487 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M328 81L329 82L328 81M361 81L361 83L363 83L363 81L361 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M377 81L378 82L377 81M395 81L395 82L398 82L395 81M399 81L400 82L399 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M436.667 81.3333L437.333 81.6667L436.667 81.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M487 81L488 82L487 81M489 81L490 84L489 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M335 82L336 83L335 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M365 82L365 84L367 84L367 82L365 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M370 82L371 89L372 89L375 84L375 83L370 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M384 82L385 83L384 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M390 82L391 83L390 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M436 82L436 85C438.006 83.8734 438.006 83.1266 436 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M438 82L439 83L438 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394 83L394 86L395 86L396 83L394 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M432 83L433 84L432 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M433 83L434 84L433 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M436 83L437 84L436 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M439 83L440 84L439 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M189 84L190 85L189 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M380 84L379 88L381 86L385 86L380 84M440 84L441 85L440 84M436.667 85.3333L437.333 85.6667L436.667 85.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M438 85L439 86L438 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M444 85L445 86L444 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M318 86L319 87L318 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M340 88L337 87L336 96C339.445 95.0318 339.579 93.3717 339 90L344 92L343 102L344 102L344 96L347 96L348 96C348.803 99.7456 351.658 98.7332 355 99L352 94L355 93L355 92L350 92L350 89L340 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M373 86L374 87L373 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M376 86L377 87L376 86M398.667 86.3333L399.333 86.6667L398.667 86.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M115 87L116 92L117 87L115 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M389 87L390 88L389 87M392 87L393 88L392 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M405.333 87.6667L405.667 88.3333L405.333 87.6667M442 87L441 90L444 90L442 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M320 92L325 91L325 92L320 95L322 107C324.98 104.889 324.942 102.373 324 99L328 101L332 96L332 95L325 96L325 92L327 88L320 92M334 88L334 91L335 91L336 88L334 88M357.667 88.3333L358.333 88.6667L357.667 88.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M374 88L375 89L374 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 88L493 101L491 101L485 97L488 100L488 105L489 105L491 102L491 107L496 100L498 92L505 95L497 90L496 94L495 94L493 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M328 89L328 90L332 92L328 89M374 105L373 105L373 103L372 103L375 111L375 112L370 111L369 111L368 116L377 114L373 116L376 118C369.764 120.776 368.747 124.802 367 131L369 140L368 153L372 154L370 150L374 150L373 153L377 150L377 149L375 148L375 147C378.378 144.237 381.36 139.409 381 135L386 136L383 133L386 132C386.092 126.469 389.088 125.885 394 127L395 124L389 124L395 120L395 119L397 112L393 115L393 109L386 106L392 108L392 103L393 103L393 105L394 105L390 101L389 104L388 104L389 98L392 100L394 95L394 94L391 96L387 95L384 100L386 96L384 90C373.559 86.9484 374.021 97.2038 374 105M390 89L392 92L390 89M395 89L395 91L397 91L395 89M400 89L401 90L400 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M442 89L443 90L442 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M372 90L373 91L372 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M378.333 90.6667L378.667 91.3333L378.333 90.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M385 91L386 92L385 91M388 91L389 92L388 91M399 91L400 92L399 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M344 93L344 94L348 94L344 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M393.667 92.3333L394.333 92.6667L393.667 92.3333M498 92L496 100L494 99L494 100L491 107L491 102L489 105L488 105L488 100L484 100L487 113C480.512 117.206 484.118 139.32 488 145L488 146L486 150L487 150L487 148L488 148L488 153L490 153C490.386 148.379 491.675 138.187 488 135L492 114L493 114L493 117L500 117L499 135L500 152L498 152C499.046 157.637 497.076 168.523 502 172L499 192L503 195L504 195L502 171L504 171C502.956 167.867 501.782 164.195 505 165L502 144L502 143L502 142C506.331 141.134 505.653 135.531 503 135C505.287 125.393 509.168 94.9501 498 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M116 93L117 96L116 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M402 93L404 97L402 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M429 93L429 95L431 95L431 93L429 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M357 94L358 95L357 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M396.333 94.6667L396.667 95.3333L396.333 94.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500.333 94.6667L500.667 95.3333L500.333 94.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M8 96L8 103L9 103L11 96L8 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M373 96L374 97L373 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M381 96L381 97L384 97L381 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M398.667 96.3333L399.333 96.6667L398.667 96.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M423.667 96.3333L424.333 96.6667L423.667 96.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M329 101L334 98L329 101M335 98L335 99L339 99L335 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M498 97L498 101L499 101L498 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M505 98L505 102L506 102L505 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M327 102L335 106L335 107L330 107L334 110L334 111L324 113L325 116L321 121L323 119L324 122L321 122L320 132L330 133L332 129C334.469 130.497 335.333 131.034 336 128L329 130L329 126L326 127L327 123L331 126L329 119L327 121L331 112L336 112L337 99L327 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M357 99L358 100L357 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M380 99L382 103L383 103L384 100L380 99M445 99L444 101L446 101L445 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504.333 99.6667L504.667 100.333L504.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M396.333 100.667L396.667 101.333L396.333 100.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 100L449 101L448 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M449 100L448 103L449 103L449 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M450 100C449.302 104.086 450.5 107.631 454 110L455 106L450 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M451 100L454 106L455 100L451 100M483 100L483 104L484 104L483 100M335.333 101.667L335.667 102.333L335.333 101.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M346 101L345 106C349.172 105.861 351.072 105.254 352 101L350 105L346 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M356 101L357 102L356 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M362 101L361 103L363 103L362 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 101L452 102L451 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 101L485 102L484 101M494 101L495 102L494 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 101L501 102L500 101M445 105L448 102L445 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M87 103L86 109L87 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M342 103L339 104L339 109L339 110L339 111L343 113L344 103L342 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 103L449 104L448 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497 103L498 104L497 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M353 104L354 105L353 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M368 104L371 106L368 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M384 104L381 108L386 104L384 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M449 104L450 105L449 104M451 104L452 105L451 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M326 105L327 106L326 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M449 105L449 112L452 113L454 110L449 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M450 105L451 106L450 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M452 105L453 106L452 105M454 105L455 106L454 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M405 106L407 111L405 106M434.667 106.333L435.333 106.667L434.667 106.333M455 106L456 107L455 106M483.333 106.667L483.667 107.333L483.333 106.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502 106L503 107L502 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M338 107L339 108L338 107M347 107L344 113L350 113L350 112L350 107L347 107M354 107L357 110L354 107M368 107L370 109L368 107M394 107L394 109L396 109L396 107L394 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M441 107L438 113L439 110L435 112C437.714 113.809 439.807 117.952 436 117L438 121L434 120L433 124C439.519 122.398 445.53 112.922 441 107M448 107L449 108L448 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M454.333 107.667L454.667 108.333L454.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M322 108L321 112L325 112L322 108M325 108L326 109L325 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M366 108L367 109L366 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M384 108L385 109L384 108M432 108L433 109L432 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 108L452 109L451 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M488.667 108.333L489.333 108.667L488.667 108.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 108L498 111L496 108M504 108L504 116L505 116L504 108M42 109L42 118C46.1108 115.397 45.3749 111.964 42 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M344 109L345 110L344 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M399 109L400 110L399 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M449 109L450 110L449 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M450 109L451 110L450 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 109L455 110L454 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 109L484 114L485 114L484 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M383 110L385 115L386 115L383 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M449 110L450 111L449 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M451 110L452 111L451 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 110L483 117L484 117L483 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M83 117L85 117L87 112C82.9356 111.378 82.1362 113.21 83 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M320 111L321 112L320 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M386 111L387 112L386 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M438.667 111.333L439.333 111.667L438.667 111.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M485 111L485 113L487 113L485 111M174 112L175 113L174 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M323 112L324 113L323 112M337 112L337 117L338 117L337 112M351 112L352 113L351 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M438.667 112.333L439.333 112.667L438.667 112.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 112L496 116L497 116L496 112M113 113L115 115L115 113L113 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M355 113L356 114L355 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M357 113L358 114L357 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M390 113L390 116L391 116L390 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M441 113L442 114L441 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M347.333 114.667L347.667 115.333L347.333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M387.667 114.333L388.333 114.667L387.667 114.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M399 114L396 117L399 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M435 114L435 116L437 114L435 114M492 114L491 124L492 124L493 120L498 122L498 126L499 126L500 117L492 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M332 117L335 117L334 115L332 117M353.333 115.667L353.667 116.333L353.333 115.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 115L453 117L455 117L455 115L453 115M502 115L502 128L503 128L502 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M344.667 116.333L345.333 116.667L344.667 116.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M114 117C113.112 120.795 114.055 122.156 118 122L114 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M351.333 117.667L351.667 118.333L351.333 117.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M377 117L377 124L373 126L373 139L374 139C375.089 135.726 377.835 131.713 375 129L375 128C377.662 127.856 378.636 127.181 379 130L382 130L383 130L383 126L378 126L378 125L381 122L382 122L383 125L385 120L380 124L379 124L379 117L377 117M388 117L386 121L388 117M447 117L445 123L446 123L450 118L449 118L448 121L447 121L447 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M320 118L321 119L320 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M323 118L324 119L323 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M332 118L333 125L337 124L335 118L332 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M362.667 118.333L363.333 118.667L362.667 118.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M371 118L372 119L371 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M398 118L398 119L401 119L398 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M447 118L448 119L447 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M448 118L447 120L449 120L448 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504 118L503 135C506.529 131.917 505.718 122.095 504 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M505.333 118.667L505.667 119.333L505.333 118.667M322 119L319 121L319 126L321 126L321 122L324 122L324 120L322 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M368.667 119.333L369.333 119.667L368.667 119.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M390.667 119.333L391.333 119.667L390.667 119.333M441 119L442 120L441 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M320 120L321 121L320 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M349 120L350 121L349 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M397 120L401 123L397 120M401 120L402 121L401 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M447 120L448 121L447 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452 120L451 123L452 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M495.667 120.333L496.333 120.667L495.667 120.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M373.333 121.667L373.667 122.333L373.333 121.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446 121L446 124L447 124L446 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M505 121L505 137L506 137L505 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M343 122L340 134L343 134L343 135L340 136L344 139L346 135L346 131L346 130L342 127L342 125L345 123L343 122M347 122L346 124L348 124L347 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M351 122L352 123L351 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M357 122L358 123L357 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 122L501 123L500 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M339 123L340 124L339 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M353 123L354 124L353 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M396 123L397 124L396 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M398 124L399 125L398 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450.667 124.333L451.333 124.667L450.667 124.333M490 124L488 135L490 148L491 148L494 145L493 141L492 141L492 143L491 143L494 138L494 142L495 142L494 134L493 134L491 137L493 132L490 124M493 124L494 125L493 124M323.667 125.333L324.333 125.667L323.667 125.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M352 125L353 129L353 128L352 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M435 125L434 131L436 131L435 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M319 126L319 132L320 132L319 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M403 126L404 127L403 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456.333 126.667L456.667 127.333L456.333 126.667M499 126L499 131L500 131L499 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M339 127L340 128L339 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M365 127L365 129L367 129L365 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M371 127L372 128L371 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M400 127L398 128L401 131L400 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M437.333 127.667L437.667 128.333L437.333 127.667M450 127L451 128L450 127M465 127L466 128L465 127M324 128L325 130L326 130L327 128L324 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M389 129L390 135L391 135L394 129L389 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M441 130L441 131L445 130L446 130L448 132L449 129L441 130M459 128L458 130L460 130L459 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M485 128L486 129L485 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M339 129L339 132L341 131L341 130L339 129M347 129L347 130L349 131L347 137L352 137L352 130L347 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M395 129L395 132L396 132L395 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 129L491 130L490 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M442 130L443 131L442 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M443 130L444 131L443 130M447 130L448 131L447 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450.333 130.667L450.667 131.333L450.333 130.667M487 130L488 131L487 130M484 131L484 156L487 157L487 159L484 162C487.042 164.153 485.742 166.693 485 170L489 171L488 168L494 162L492 163L492 162L490 157L492 158L492 157L493 155L492 149L490 153L488 153L488 148L487 148L487 150L486 150L488 146L488 145L484 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491 131L491 133L493 133L491 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 133L499 132L496 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M325 134C327.396 134.575 327.487 134.475 328 132L325 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M338 132L339 133L338 132M393.333 132.667L393.667 133.333L393.333 132.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M423 132L423 135L425 134L425 133L423 132M433 132L432 136L435 132L433 132M438.667 132.333L439.333 132.667L438.667 132.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497.333 132.667L497.667 133.333L497.333 132.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M498 132L498 134L500 134L498 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M320 133L319 140L320 140L324 133L320 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M356 133L357 134L356 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M399 133L400 139L401 133L399 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M447 133L448 134L447 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M491 133L492 134L491 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492 133L491 137L492 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M117.333 134.667L117.667 135.333L117.333 134.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M319 134L318 136L319 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M325 140L324 140L321 137L319 147L323 144L322 147L325 148L322 150L326 151L326 152L318 154L326 155L326 156L321 155L321 161L325 160L323 161L323 162L326 162L326 163L322 164L322 165C324.993 164.936 326.346 165.054 327 162L328 162C329.92 164.957 331.696 164.883 335 164C333.702 159.901 332.553 157.024 328 159L332 151L336 158L337 150L336 145L340 145L341 141L339 144L333 146L334 149L330 148C329.612 144.088 327.781 143.298 324 143L324 141L328 141L333 135C329.196 134.191 326.729 136.804 325 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M363 134L364 135L363 134M394 134L393 139C395.28 137.36 395.5 136.362 394 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 134L499 135L498 134M87 135L86 138C88.5655 137.449 88.8602 136.86 87 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M319 135L320 136L319 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M334 136L334 137L339 135L334 136M355 135L356 136L355 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 145L448 151L454 152L453 149L450 147L453 147L455 140L455 135C449.138 137.06 450.599 140.545 448 145M499 135L500 138L501 138L501 135L499 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M360 136L360 143L357 143L358 146L356 146C357.153 149.772 357.841 152.03 355 155L356 151L354 156L351 154L351 158L360 162L360 163L358 166L357 166L357 163L356 163L355 174L360 174L361 180L367 164L360 168L359 165L370 163L370 162L364 159L361 145L368 144L367 141L361 142L361 141L367 136L362 137L363 140L360 139L361 137L360 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M384 142L385 142L386 138L391 138L391 137C386.909 136.081 384.661 138.025 384 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M424 136L425 137L424 136M428 136L429 137L428 136M456 136L457 139L455 138L457 143L461 141L461 137L459 140L458 140L456 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M488 136L489 137L488 136M504 136L505 137L504 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M456.333 137.667L456.667 138.333L456.333 137.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M345 138L350 140L350 139L345 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M376 138L375 141L376 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M450 138L450 141L452 141L452 138L450 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M454 138L453 140L455 140L454 138M492 138L492 141L493 141L494 138L492 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499.333 138.667L499.667 139.333L499.333 138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M501 138L501 141L502 141L501 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M268.667 139.333L269.333 139.667L268.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M330 139L329 140L332 143L330 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M335 139L336 140L335 139M352 140L352 141L358 141L352 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M390.667 139.333L391.333 139.667L390.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M491 139L491 143L492 143L491 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M493 139L493 143L494 143L493 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M260 144L272 143C267.823 139.892 262.782 138.96 260 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M267.667 140.333L268.333 140.667L267.667 140.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M269 140L269 141L278 147L269 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M270 140L271 141L270 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M271.667 140.333L272.333 140.667L271.667 140.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M382 140L378 143L381 147L382 147L382 140M393 140L390 143L396 145L395 140L393 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504 140L502 142L502 143L502 144L504 144L504 159L505 159L504 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M505 140L505 144L506 144L505 140M273 141L274 142L273 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M343 141L344 142L343 141M388 141L388 143L390 143L390 141L388 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 141L488 142L487 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 141L500 142L499 141M274 142L275 143L274 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M318 142L318 147L319 147L318 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M336 142L337 143L336 142M350.667 142.333L351.333 142.667L350.667 142.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M353 142L354 143L353 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M396.667 142.333L397.333 142.667L396.667 142.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 142L499 145L500 142M273 143L273 145L275 145L273 143M275 143L276 144L275 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M342 143L343 144L342 143M345 143L346 144L345 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M354 143L353 144L353 145L354 146L355 146L356 145L356 144L354 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M384 146L388 145L384 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M424.667 143.333L425.333 143.667L424.667 143.333M459.333 143.667L459.667 144.333L459.333 143.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M493 143L494 144L493 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M418 144L419 145L418 144M488 144L489 145L488 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 144L493 145L492 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M275 145L276 146L275 145M277 145L278 146L277 145M328 145L329 146L328 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M341 145L343 151L340 150L346 156L343 146L346 147L341 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M364 145L363 148L364 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M371 145L371 147L373 147L371 145M498 145L498 160L499 160L498 152L500 152L498 145M172 146L172 151L176 150L174 146L172 146M253 146L253 148L255 146L253 146M276 146L277 147L276 146M278 146L280 167L283 167C282.945 160.361 282.229 151.317 278 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M349 146L349 147L353 148L353 147L349 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M427 146L428 147L427 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 146L452 147L451 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M458 146L458 148L460 148L458 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 146L501 147L500 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M274 147L275 148L274 147M358 149L361 147L358 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M382 148L382 149L386 148L382 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394.667 147.333L395.333 147.667L394.667 147.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M443 147L442 148L445 154L446 154L445 150L447 151L443 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M347 148L347 150L349 150L349 148L347 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M354.333 148.667L354.667 149.333L354.333 148.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M443.333 148.667L443.667 149.333L443.333 148.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 148L494 152L495 152L494 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M498 148L499 149L498 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M267 149L265 156C270.797 160.526 271.877 163.901 271 171C278.544 166.246 276.035 150.428 267 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M389 149L389 150L393 150L389 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M174 150L175 151L174 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M279 150L280 151L279 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M328 150L329 151L328 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M366 150L367 151L366 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M398 150L399 151L398 150M445.333 150.667L445.667 151.333L445.333 150.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M71 151L70 154L74 155L73 151L71 151M343 151L343 153L345 153L343 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394 151L395 152L394 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 151L492 152L494 153L495 156L492 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M245 152C237.997 158.948 229.806 183.199 246 186C245.993 176.997 242.399 171.369 249 164L251 170L252 160L249 161L247 152L245 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M317.667 152.333L318.333 152.667L317.667 152.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M336.333 152.667L336.667 153.333L336.333 152.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M383 152L384 153L383 152M385 152L388 154L388 153L385 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M392 152L391 156L392 156L392 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M421 152L422 153L421 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 152L487 153L486 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M491.333 152.667L491.667 153.333L491.333 152.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492.667 152.333L493.333 152.667L492.667 152.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M317 153L317 156L319 155L319 154L317 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M326 153L328 156L328 153L326 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M339.333 153.667L339.667 154.333L339.333 153.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M343 153L344 154L343 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 153L448 163C450.01 159.704 451.438 155.601 448 153M453 153L454 154L453 153M505 153L505 158L506 158L505 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M344 154L345 155L344 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M376 154L378 160L382 158L376 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M383 154L384 155L383 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M341 155L342 156L341 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M357 155L356 159L362 162L362 161L359 155L357 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394 155L390 170L390 173L390 174L391 178L396 176L395 171L399 170L394 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420 155L421 156L420 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 155L488 158L489 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M492 155L492 158L493 158L492 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M493 155L492 157L494 157L493 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M382 156L382 157L388 158L388 156L382 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M455.333 156.667L455.667 157.333L455.333 156.667M494 156L495 157L494 156M178 157L179 158L178 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M339 157L340 158L339 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M341 157L344 159L341 157M370 157L370 159L372 157L370 157M374 157L375 158L374 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M390 157L390 160L392 157L390 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M416 157L417 169L416 165L423 169L423 163C418.217 163.18 417.813 160.841 416 157M493 157L494 158L493 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 157L501 158L500 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M160 160L161 161L163 158L160 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M396 158L396 161L397 161L396 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 158L495 161L496 161L495 158M68 163L75 163C72.8403 159.132 70.1597 159.132 68 163M158 159L159 160L158 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M317.333 159.667L317.667 160.333L317.333 159.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M336.333 159.667L336.667 160.333L336.333 159.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M382 159L382 160L386 161L382 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 159L454 160L453 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487 159L488 160L487 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M488 159L487 161L489 161L488 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M495 159L496 160L495 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M131 161L131 162L140 161L131 161M331 160L330 163L333 163L331 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M341 160L342 161L341 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M344 160L344 162L346 160L344 160M389 160L390 161L389 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M406.667 160.333L407.333 160.667L406.667 160.333M426 160L427 163L428 163L428 160L426 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M338 161L336 166L336 167L338 170L333 171L337 171L332 173L333 176L330 177L330 181L331 181L333 178L333 181L335 186L337 186L337 190L337 191L333 192L333 193L338 192L335 198L335 199L342 196L342 195L339 196L339 190L346 184L340 178L343 180L344 174L338 177L338 176C341.342 174.205 342.391 167.946 338 167L338 166L338 161M351 163L354 161L351 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M373 161L373 165L374 165L373 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M404 161L405 162L404 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M487 161L489 166L490 166L487 161M492 161L493 162L492 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 161L499 173L493 174L496 178L500 176L499 179L500 179L502 172L498 161M504.333 161.667L504.667 162.333L504.333 161.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M317.333 162.667L317.667 163.333L317.333 162.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M320 162L321 163L320 162M379 163L380 166L377 165L382 168L382 171L383 171L388 170L388 166L384 168L387 162L379 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M400 162L401 163L400 162M447 162L448 163L447 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492 162L493 163L492 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M343 163L344 164L343 163M375.333 163.667L375.667 164.333L375.333 163.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M382 163L385 165L385 164L382 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M388 163L389 164L388 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M91 174C90.651 171.701 90.8703 168.364 89.6667 166.333C87.2873 162.319 78.1109 172.213 91 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M174 164L178 182L192 168C184.825 168.308 180.839 170.372 176 164L174 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M319 164L320 165L319 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M341 164L343 166L341 164M348.333 164.667L348.667 165.333L348.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M350 164L348 168L351 171L352 171L350 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 164L479 166L481 166L481 164L479 164M485.333 164.667L485.667 165.333L485.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 164L500 165L499 164M503 164L504 171L502 171L504 181L505 181L503 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M343 165L344 166L343 165M368.333 165.667L368.667 166.333L368.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M420 165L421 166L420 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M425 165L425 170L426 170L425 165M427 165L428 166L427 165M446.667 165.333L447.333 165.667L446.667 165.333M505.333 165.667L505.667 166.333L505.333 165.667M138 166L138 168L141 168L141 166L138 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M322 166L322 173L323 173L324 166L322 166M325 169L332 169C329.316 166.498 327.317 165.889 325 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M334 166L333 168L335 168L334 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M344.333 166.667L344.667 167.333L344.333 166.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M365.333 166.667L365.667 167.333L365.333 166.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M381 166L382 167L381 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M86 167L86 169L88 167L86 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M395 167L395 169L397 169L395 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M420 167L420 169L422 169L420 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M279 168C276.432 176.157 269.384 184.161 267.707 192.13C266.833 196.281 271.029 200.285 269.977 204.985C268.094 213.402 261.564 226.329 273.171 232.683C281.5 237.243 287.836 232.408 296 233L293 221C296.461 220.795 300.797 221.646 303.956 219.971C311.852 215.787 310 201.441 310 194C299.555 193.801 290.375 182.146 282 177L279 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M319 168L318 169L319 172L320 172L321 168L319 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M353 168L353 171L355 168L353 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M375 168L376 169L375 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M442 168L442 173L443 173L442 168M448 168L449 169L448 168M505 168L505 190L506 190L505 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M343 169L344 170L343 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M365 169L366 170L365 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420 169L420 173L423 172L420 169M433 169L432 171L434 171L433 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M318 170L319 171L318 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M375 170L377 172L377 170L375 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M328 171L322 177C326.872 176.517 329.593 176.029 331 171L328 171M385 171L385 173L387 173L387 171L385 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M414 171L416 176L414 171M493 171L492 173L494 173L493 171M252 175C256.034 179.616 264.171 176.491 268 173L252 175M269 172L270 173L269 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M325.667 172.333L326.333 172.667L325.667 172.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M371.333 172.667L371.667 173.333L371.333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M373 172L374 173L373 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M382 172L380 177L385 178L382 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M397 173L400 178L401 172L397 173M403.333 172.667L403.667 173.333L403.333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M427 172L429 176L430 176L427 172M447 172L447 175L449 174L449 173L447 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M318 173L319 174L318 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M344 173L345 174L344 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M351 173L352 174L351 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M436.333 173.667L436.667 174.333L436.333 173.667M486 173L485 179L486 179L486 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497 173L498 174L497 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M67 176L71 185C75.7775 182.568 74.9191 179.731 75 175L67 176M337 174L338 175L337 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M368 174C366.399 177.151 365.875 178.947 369 181L368 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M385 174L387 176L387 174L385 174M496 176L500 175L496 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M319 175L320 176L319 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M345 176L346 177L345 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M371 176L373 181L371 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M377 176L377 179L378 179L377 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M383 176L384 177L383 176M427 176L428 177L427 176M436 179L439 176L436 179M443 176L444 177L443 176M446 176L444 180L449 178L449 177L446 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496 176L497 177L496 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M165 177L166 178L165 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M161 182L169 179C165.445 177.09 162.892 178.689 161 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M167.667 177.333L168.333 177.667L167.667 177.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M318 177L318 178L321 178L318 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446 177L447 178L446 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M163 178L164 179L163 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M257 184L257 185C262.506 184.064 267.465 182.462 271 178L257 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M345.333 178.667L345.667 179.333L345.333 178.667M352 178L354 180L352 178M365.333 178.667L365.667 179.333L365.333 178.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M379 178L378 184L379 184L379 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M389 178L390 179L389 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420.333 178.667L420.667 179.333L420.333 178.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M161 179L162 180L161 179M168 179L169 180L168 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M321.333 179.667L321.667 180.333L321.333 179.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M328 179L326 183L327 184L330 183L328 179M389 179L390 180L389 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M396 179L395 181L396 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M399 179L400 183L401 183L399 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 179L500 184L501 184L500 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M160.333 180.667L160.667 181.333L160.333 180.667M165.667 180.333L166.333 180.667L165.667 180.333M322.333 180.667L322.667 181.333L322.333 180.667M382 180L382 181L385 181L382 180M396 180L397 181L396 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502 180L504 182L502 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M163 181L164 182L163 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M347.333 181.667L347.667 182.333L347.333 181.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M387.667 181.333L388.333 181.667L387.667 181.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M13 184L14 201C18.8593 197.938 23.1752 179.818 13 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M330 182L331 183L330 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M338 182L339 183L338 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M366 182L367 183L366 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M383 182L385 185L383 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420 182L421 183L420 182M316 183L317 184L316 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M324 183L323 184L326 187L324 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M376 183L377 184L376 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M415.667 183.333L416.333 183.667L415.667 183.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M390 184L392 186L390 184M397 184L398 185L397 184M400.333 184.667L400.667 185.333L400.333 184.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M420 184L421 185L420 184M499 184L499 187L500 187L499 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M321 185L322 186L321 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M330 185L331 186L330 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M341 185L341 187L343 187L343 185L341 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M393.667 185.333L394.333 185.667L393.667 185.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M359 186L361 191L359 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M383 190L387 186L383 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 186L489 189L490 189L489 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M365.333 187.667L365.667 188.333L365.333 187.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 187L496 194L497 194L502 195L503 195L498 191L498 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500.333 187.667L500.667 188.333L500.333 187.667M504 187L504 190L505 190L504 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M367 188L368 189L367 188M381.333 188.667L381.667 189.333L381.333 188.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M396 188L396 190L398 190L398 188L396 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M327 189L326 191L327 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M343.333 189.667L343.667 190.333L343.333 189.667M393 189L394 190L393 189M498.333 189.667L498.667 190.333L498.333 189.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M67 190L67 193L72 190L67 190M160 190L160 191L166 192L160 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M327.667 190.333L328.333 190.667L327.667 190.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M399 190L400 191L399 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M423 190L424 191L423 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M323 191L324 192L323 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M327 191L328 192L327 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M358 191L359 192L358 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M367 191L368 192L367 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M154 192L155 193L154 192M164 192L165 193L164 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M325 192L326 193L325 192M328 192L329 193L328 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M405.667 192.333L406.333 192.667L405.667 192.333M491 192L492 195L491 192M163 193L164 203L165 203L163 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M322 193L321 195L323 195L322 193M330 193L331 194L330 193M383 193L385 197L386 196L383 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504 193L505 194L504 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M246 194L247 195L246 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M343 194L346 197L343 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M380 194L382 196L380 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M392 194L387 197L388 206L390 204L391 204L393 206C392.763 202.269 392.699 199.136 396 197L396 196L392 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M504 194L505 195L504 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 195L499 199L500 199L499 195M503 195L505 197L505 195L503 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M326.667 196.333L327.333 196.667L326.667 196.333M335 196L336 197L335 196M348 196L349 197L348 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M351.667 196.333L352.333 196.667L351.667 196.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M398.333 196.667L398.667 197.333L398.333 196.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M406 196L407 197L406 196M489 196L490 202L493 201L493 197L489 196M319 197L320 200L321 200L322 197L319 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M341 197L342 198L341 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M370.333 197.667L370.667 198.333L370.333 197.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M376.333 197.667L376.667 198.333L376.333 197.667M495 197L496 198L495 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M495 198L495 200L498 201L499 198L495 198M504 197L504 209L505 209L504 197M332 198L333 199L332 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M384 198L384 202L385 202L384 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M423 198L422 202L423 202L423 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M496 198L497 199L496 198M338 199L339 200L338 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M339 199L340 200L339 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M404 200L404 201L408 200L404 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M498 201L495 200L496 204L500 199L498 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 199L504 200L503 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M330 200L331 201L330 200M338 200L339 201L338 200M340 200L341 201L340 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M352 200L352 202L355 202L355 200L352 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M369 200L370 201L369 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M375 200L377 202L377 200L375 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491 200L492 204L493 204L491 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 200L494 203L495 203L494 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504 200L505 201L504 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 201L7 208L11 205L7 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M499 201L494 203L489 213L491 219L488 217L488 228C484.244 228.822 485.837 230.862 488 233C486.423 235.855 487.411 237.225 490 239L492 230L493 230L492 234L493 234L496 232L497 241L495 242L496 243C500.221 237.368 495.906 231.253 493 226L495 227L494 219L492 220L492 213L495 214L494 208L495 208L495 210L496 210L499 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 201L501 202L500 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M336 202L337 203L336 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 202L500 203L499 202M165 203L169 207L165 203M253 203L253 204L255 208L256 208L256 203L253 203M491 203L489 211C485.818 211 483.095 226.949 488 228L488 217L491 219L489 213L494 206L491 207L493 204L491 203M498 203L499 204L498 203M503 203L504 204L503 203M376 204L376 207L379 206L379 205L376 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M398 204L399 205L398 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M419.333 204.667L419.667 205.333L419.333 204.667M497 204L498 205L497 204M18 223C19.3228 219.802 21.7003 210.227 19.3812 207.434C16.2128 203.618 9.82602 205.602 10.5069 210.876C11.1084 215.533 17.1727 217.643 18 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394.667 205.333L395.333 205.667L394.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491 205L491 207L493 205L491 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M495.333 205.667L495.667 206.333L495.333 205.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M346 207L346 208L352 210L350 206L346 207M357 206L358 207L357 206M362 206L363 207L362 206M169 207L172 209L172 210C168.751 211.806 168.401 213.383 169 217L170 217L175 208L169 207M332 207L333 208L332 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M388 208L388 209L393 208L388 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M401 207L402 208L401 207M7 208L7 211L8 211L7 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M337 208L337 209L340 209L337 208M361.667 208.333L362.333 208.667L361.667 208.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492.333 208.667L492.667 209.333L492.333 208.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M494 208L494 213L495 213L494 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M346 209C345.59 212.477 345.33 214.922 349 216L348 209L346 209M374 213L381 213L378 209L374 213M504 209L504 213L505 213L504 209M260 210L261 211L260 210M368.333 210.667L368.667 211.333L368.333 210.667M7.33333 211.667L7.66667 212.333L7.33333 211.667M335 211L335 213L338 213L338 211L335 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M347 211L348 212L347 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M371 211L371 214L372 214L371 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M392 211L393 212L392 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M393 211L395 214L393 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M405 211L406 212L405 211M424 212L422 213L422 214L424 212M350.667 213.333L351.333 213.667L350.667 213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M393 213L394 214L393 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492 213L492 220L493 220L494 213L492 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M504 213L504 216L505 216L504 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7.33333 214.667L7.66667 215.333L7.33333 214.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M395 214L396 215L395 214M399 214L400 215L399 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 214L495 215L494 214M353 215L354 216L353 215M424 215L426 217L424 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M493 215L494 216L493 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M375 216L376 217L375 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M384 216L385 217L384 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M393 216L394 217L393 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M435 216L436 217L435 216M438 216L438 218L440 218L438 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M439 216L440 217L439 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 216L493 219L494 219L493 216M504 216L504 220L505 220L504 216M170.333 217.667L170.667 218.333L170.333 217.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M396 217L397 218L396 217M399 217L400 218L399 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M375 219L373 223L375 219M171 220L177 225L177 227L173 228L171 237C174.326 235.327 187.68 227.67 182.396 223.048C179.589 220.592 174.428 221.894 171 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M397 220L398 221L397 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M399 220L397 222L397 223L398 231L399 231L402 228L402 227L399 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M425 222L426 223L425 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492 222L492 225L493 225L492 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M394 223L395 224L394 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M405 223L407 225L405 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M489.333 224.667L489.667 225.333L489.333 224.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 224L491 229L492 229L491 224M17 225C15.1336 230.043 17.0388 233.274 19 238C13.9367 241.317 18.4659 244.845 23 244L22 228L17 225M447.333 225.667L447.667 226.333L447.333 225.667M494 225L495 226L494 225M378 226L379 227L378 226M407 226L408 227L407 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M493 226L495 229L493 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M385 227L385 229L387 229L387 227L385 227M484 228L484 236L486 238L487 238L484 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M486 229L490 233L490 228L486 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M378 229L378 231L380 231L380 229L378 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M400 229L401 230L400 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M425.333 229.667L425.667 230.333L425.333 229.667M492 230L490 239L487 238L488 247L489 247L489 241C493.775 241.114 493.563 233.188 492 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M485 232L486 233L485 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 232L488 233L487 232M493 232L494 261L499 256L495 256L499 250L498 254L505 233L502 240L497 235C497.539 237.914 498.701 241.458 495 242L497 241L497 240L496 232L493 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503.667 232.333L504.333 232.667L503.667 232.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M384 233L385 234L384 233M502 233L503 234L502 233M397 234L399 236L399 234L397 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M491.333 234.667L491.667 235.333L491.333 234.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 234L498 235L501 235L498 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M502 240L503 234C499.435 235.436 498.528 237.756 502 240M504 234L505 235L504 234M493 235L493 238L494 238L493 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504.333 235.667L504.667 236.333L504.333 235.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M489 236L490 237L489 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M168 239L171 237L168 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503.333 237.667L503.667 238.333L503.333 237.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M403 238L404 239L403 238M165.667 239.333L166.333 239.667L165.667 239.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M491 239L491 243L492 243L493 239L491 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M493 239L494 240L493 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503.333 239.667L503.667 240.333L503.333 239.667M162 242L165 240L162 242M404 240L407 242L404 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M502 240L502 245L503 245L502 240M489 241L489 249L492 248L489 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M160.667 242.333L161.333 242.667L160.667 242.333M492 242L493 248L492 242M158.667 243.333L159.333 243.667L158.667 243.333M408 243L408 244L411 245L408 243M157 244L158 245L157 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M407 244L407 245L415 251C413.521 246.754 411.406 244.897 407 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M155.667 245.333L156.333 245.667L155.667 245.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 245L493 246L492 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 245L503 246L502 245M152 248L155 246L152 248M174.667 246.333L175.333 246.667L174.667 246.333M401 246L402 247L401 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M402.667 246.333L403.333 246.667L402.667 246.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M404 246L405 247L404 246M413 246L414 247L413 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496 246L496 250L497 250L496 246M500 246L500 252L501 252L502 246L500 246M493 247L493 250L494 250L493 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M150.667 248.333L151.333 248.667L150.667 248.333M173 248L174 252L175 252L173 248M400 248L401 249L400 248M414.667 248.333L415.333 248.667L414.667 248.333M491 248L492 249L491 248M148.667 249.333L149.333 249.667L148.667 249.333M165 249L160 264L161 264L165 249M489.667 249.333L490.333 249.667L489.667 249.333M146.667 250.333L147.333 250.667L146.667 250.333M413 250L414 251L413 250M415 252L418 251L415 252M493 250L494 251L493 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497 250L495 256L499 256L498 259L499 259L498 254L499 250L497 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 250L504 251L503 250M144.667 251.333L145.333 251.667L144.667 251.333M156.333 251.667L156.667 252.333L156.333 251.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M416 251L421 254L416 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 251L482 253L482 251L480 251M487 251L489 257L486 255L485 258L483 258L482 254L481 254L480 263C483.527 262.439 485.063 261.674 485 258L490 263L495 264L490 257L491 257L491 259L492 259L489 254L491 251L487 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M493 251L493 255L494 255L493 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M23 252L23 254L25 254L25 252L23 252M143 252L144 253L143 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M480 252L480 254L482 254L480 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 252L501 253L500 252M82 253L82 256L84 253L82 253M142 253L143 254L142 253M141 254L142 255L141 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M480 254L480 257L481 257L480 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M140 255L141 256L140 255M465 255L466 256L465 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M489 255L490 256L489 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 255L493 261L494 261L493 255M139 256L138 259L139 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M419 256L419 257L425 256L419 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 256L503 267C505.796 264.551 505.357 259.284 504 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M480 257L480 260L481 260L480 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 257L500 258L499 257M479 258L480 259L479 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M485 258L481 263L484 266L484 267C478.257 270.723 478.621 284.175 485 287L483 290L485 292L487 291L485 293L485 294L488 305L485 307C490.945 306.698 491.511 298.762 493 294L488 285L488 284L493 284L492 276L495 274L489 275L489 270L490 270L490 273L493 273L492 269L485 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M137 259L138 260L137 259M140 259L141 260L140 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M483 259L484 260L483 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496 259L497 260L496 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 259L498 260L497 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 259L504 260L503 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M82 260L84 263L84 260L82 260M136 260L137 261L136 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M421 261L426 260L421 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M426.667 260.333L427.333 260.667L426.667 260.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M482 260L483 261L482 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M488 260L489 261L488 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M495 260L496 261L495 260M504 260L505 261L504 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M11 263C13.7634 267.422 12.3822 270.258 19 272L20 269L27 268C23.1658 261.047 18.1997 259.95 11 263M135 261L136 262L135 261M425 261L426 262L425 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M483 261L484 262L483 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M494 261L495 262L494 261M7 262L8 263L7 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M134 262L135 263L134 262M408 262L409 263L408 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M486 262L486 264L488 264L488 262L486 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 262L497 268L496 268L496 265L490 264C489.403 266.84 488.911 268.611 492 269L493 273L491 272L492 275L494 275L495 272L499 272L499 271L496 272C498.171 268.218 499.429 265.303 496 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497.333 262.667L497.667 263.333L497.333 262.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 263L8 264L7 263M133 263L134 264L133 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M419 263L419 264L422 264L419 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450 263L451 264L450 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M491 263L491 265L494 265L494 263L491 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500.333 263.667L500.667 264.333L500.333 263.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M7.33333 264.667L7.66667 265.333L7.33333 264.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M132 264L131 267L132 264M406 264L407 265L406 264M418 264L419 265L418 264M464 264L465 265L464 264M480 264L481 265L480 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M494.333 264.667L494.667 265.333L494.333 264.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M416.333 265.667L416.667 266.333L416.333 265.667M444 265L445 266L444 265M481 265L481 268L482 268L481 265M485 265L486 266L485 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M482.667 266.333L483.333 266.667L482.667 266.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 269L491 269L494 267L490 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M130.333 267.667L130.667 268.333L130.333 267.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 267L488 268L487 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M494 267L494 272L495 272L494 267M496 267L497 268L496 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 267L501 275L501 274L499 273L503 271L499 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 267L505 272L505 267L503 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M404 268L405 269L404 268M410 268L411 269L410 268M464 268L460 273L460 274L460 275L462 275C459.252 282.541 462.239 299.042 455 303L455 307C458.768 307 457 314.001 457 317L458 317L458 313L459 313L461 322L458 332L463 327L459 328L465 325L465 324L463 323L464 317L466 315L470 315L467 312L469 308L470 311L471 311L469 305L472 304L472 303L469 298L470 298L470 301L471 301L472 296C467.13 295.674 469.136 291.43 470 288L468 281L468 277L465 276L466 268L464 268M480.333 268.667L480.667 269.333L480.333 268.667M129 269L130 270L129 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 269L487 271L484 270L484 275L485 275L489 269L487 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493 269L494 270L493 269M495 269L496 270L495 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M128 270L129 271L128 270M442.333 270.667L442.667 271.333L442.333 270.667M489 270L489 273L490 273L489 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497 270L496 272L498 272L497 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M408.333 271.667L408.667 272.333L408.333 271.667M426.667 271.333L427.333 271.667L426.667 271.333M444 271L445 272L444 271M480 271L480 276L481 276L480 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 271L493 272L492 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M127.333 272.667L127.667 273.333L127.333 272.667M502 272L502 277L505 272L502 272M424 273L425 274L424 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 275L492 275L490 273L489 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M499.667 273.333L500.333 273.667L499.667 273.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M126 274L125 286L126 286L126 274M490 274L491 275L490 274M497 274L498 275L497 274M443 276L445 281L446 281L446 276L443 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 276L481 284L486 283L487 277L486 277L486 279L485 279L484 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 276L492 278L495 278L495 276L492 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M502 277L504 279L504 280L502 283C505.716 282.204 505 279.363 505 276L502 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452 277L453 280L451 283L454 283L452 277M497 277L498 284L499 284L498 281L500 278L497 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M488 278L489 279L488 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M498 278L499 279L498 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 278L501 282L502 278M44.6667 279.333L45.3333 279.667L44.6667 279.333M480 279L480 282L481 282L480 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 279L491 280L490 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 279L493 280L492 279M449 280L450 281L449 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M461 280L462 281L461 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M482 280L483 281L482 280M493 280L494 281L493 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M463 281L464 282L463 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M444 282L440 296L445 295L448 292L444 282M458.333 282.667L458.667 283.333L458.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M462 282L462 286L463 286L464 282L462 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M498 282L499 283L498 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M447 283L447 288L448 288L447 283M479 283L480 286L476 287L477 292L475 292L478 295L474 306L478 312L478 313L475 319L477 316L477 320L478 315L484 316L484 315L479 314L480 310L480 309L477 304L481 306L478 290L481 287L484 289L485 288L479 283M491 283L492 284L491 283M493.667 283.333L494.333 283.667L493.667 283.333M502 283L502 284L505 284L502 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M444 284L445 285L444 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 284L484 285L483 284M485.667 284.333L486.333 284.667L485.667 284.333M488 284L488 285L491 285L488 284M492 284L493 285L492 284M496 284L497 285L496 284M501 284L502 285L501 284M503 285C502.357 288.189 502.009 290.274 505 292L505 285L503 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M486 286L487 287L486 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 286L489 289L489 290C491.649 289.432 492.355 288.412 491 286M494.333 286.667L494.667 287.333L494.333 286.667M498 286L499 287L498 286M124 287L124 292L125 292L124 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M481 287L482 288L481 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 287L489 289L491 289L490 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M250 288L251 289L250 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M442.667 288.333L443.333 288.667L442.667 288.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 288L454 289L453 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M461 288L461 297L462 297L463 288L461 288M465 288L466 289L465 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M472 288L470 294C472.673 292.3 473.636 290.827 472 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M481 288L478 290L481 306L477 304C477.064 306.993 476.946 308.346 480 309L480 310C477.237 311.901 481.111 315.245 481 312L484 313L482 309L483 305L484 305L484 307L485 307L484 298L483 288L481 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M502 288L503 289L502 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M253 289L253 290L268 292L253 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472.333 289.667L472.667 290.333L472.333 289.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M464 290L464 292L466 292L466 290L464 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M481 290L481 294L482 294L483 290L481 290M484 290L484 294L485 294L486 290L484 290M488 290L487 296L488 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M440 291L442 294L440 291M443 291L444 292L443 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M478 291L479 292L478 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486.333 291.667L486.667 292.333L486.333 291.667M491 291L490 294L498 295L491 291M18 297L24 292L18 297M123 292L122 297L123 297L123 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 292L503 299L504 299L505 292L503 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 293L7 301L8 301L15 298L8 297L7 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M466 293L467 294L466 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502.333 293.667L502.667 294.333L502.333 293.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M460 294L461 295L460 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M484 305L485 306L488 305L487 298L485 299L485 298L487 296C480.569 291.95 484.078 301.697 484 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M484 295L485 296L484 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M463 296L463 297L466 297L463 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492.333 296.667L492.667 297.333L492.333 296.667M502 296L502 299L503 299L502 296M504 296L504 299L505 299L504 296M455 297L455 299L457 299L457 297L455 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M480 297L481 298L480 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M485 297L485 299L487 297L485 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M121 298L121 301L122 301L121 298M440 299L441 300L440 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M466 299L467 300L466 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 299L484 300L483 299M487 299L487 303L489 303L489 299L487 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 299L504 300L503 299M456 300L457 301L456 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M464 300L460 303L460 307L461 307L465 305L464 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 300L490 309L489 309L484 307L484 313L485 313L487 308L488 308L490 312L494 309L493 306L492 306L492 309L491 309L491 303L493 304L493 300L491 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M467 301L468 302L467 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M120 302L120 307L121 307L120 302M497 302L496 304L498 304L497 302M502 302L501 307L501 308L505 307L502 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503.333 302.667L503.667 303.333L503.333 302.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M466 303L464 307L468 308L466 303M491 303L492 304L491 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M71 305L71 306L75 307L74 304L71 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M457 304L458 305L457 304M489 304L489 309L490 309L489 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491 304L491 309L492 309L493 304L491 304M496 304L496 311L498 304L496 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M20.6667 305.333L21.3333 305.667L20.6667 305.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M455 305L456 306L455 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 305L482 309L483 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 305L498 308L499 308L498 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M501.667 306.333L502.333 306.667L501.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452.333 307.667L452.667 308.333L452.333 307.667M496 307L497 308L496 307M38 309L38 310C41.5487 310.807 43.9035 311.223 46 308L38 309M63 308L63 309L67 310L63 308M119 308L119 312L120 312L119 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M487 308L490 314L487 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 308L496 311L496 312L504 313L505 313L505 309L499 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M7.33333 309.667L7.66667 310.333L7.33333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 309L497 310L496 309M20 316C23.3021 314.672 23.8033 313.434 23 310C20.0594 311.62 19.5009 312.686 20 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M461 310L460 314L464 310L461 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M486 310L482 313C484.439 318.643 486.76 324.177 482 329L481 339L482 339C484.456 337.08 485.588 337.033 488 339L485 338L485 342L481 340L480 342L476 357L471 360L481 353L480 349L483 349L482 346L490 347L490 349L485 349L485 350L490 350L488 356L490 356L484 358L481 360L480 357L479 357L478 369L475 368L476 371L473 370L471 376L475 372L477 381L480 379L483 388L477 386L472 391L476 390L477 393L473 393L473 397L478 395L474 398L472 401L474 403L476 410L476 414L474 414L474 415L476 415L476 416L476 424L477 421L483 423L483 422L480 421L480 420L486 421L489 424L488 427L485 425C487.202 429.525 489.741 433.89 483 435L483 434L486 433C483.425 421.539 469.013 426.893 468 435L475 434L475 430L476 439L479 437L480 437C480.697 441.467 482.533 443.303 487 444L486 441L491 441L489 445L493 447C496.642 445.992 498.189 446.672 500 450L493 448L490 448L489 451L485 449L488 452L483 457L487 463L486 463L484 459L482 461L481 461L479 458L476 460L474 454L474 466L475 466L477 464L476 472L477 466L476 466L474 478L479 482L476 481L478 484L473 484L475 487L470 485L469 485L469 477L468 477C467.963 481.916 466.244 489.107 473 489L473 493L470 492L471 498L469 494L468 494L469 507L470 507L469 499L473 501C475.008 496.953 476.834 499.077 479 502L476 505L480 505L479 508L476 508L471 502L472 506L480 508L480 512L484 512L483 504L488 503L489 509L490 509L493 507L492 503L489 503L492 500L499 498L499 502L496 501L496 510L495 510L494 508L498 512L497 508L497 507L499 503L502 504L504 501L503 503L504 503L502 494L505 493C504.125 489.024 503.397 486.21 499 486L497 480L498 480L499 484L503 484L504 482L504 473L504 472L501 469L496 470L499 466C502.974 469.365 504.692 466.236 504 462L501 465L500 465L499 458L498 458L497 462L496 462L496 460L495 460L499 464C495.864 464.248 493.453 462.262 493 466L489 465L490 460L494 462L494 461L491 460L494 454L493 454L487 458L491 451L495 451L496 457L499 455L501 456L500 459L503 458L502 461L505 460L503 458L503 457L505 452L500 450L504 451L505 442L495 444L501 438L504 439L504 435L503 435L503 438L502 438L496 437L494 435L494 434C496.167 431.837 494.639 430.294 493 428L498 426L493 426L493 424L503 425L501 420L504 421L504 420L501 418L505 419L503 415C506.688 414.385 504.29 410.261 502 409C504.783 401.727 504.76 396.409 500 390C504.169 387.31 504.864 380.72 505 376C501.62 375.556 502.545 373.412 504 371L496 371L496 370L498 367L501 368L501 367L500 363C497.226 358.219 499.77 353.833 505 353L505 346L504 346L504 352L498 347L503 350L499 342L503 345C505.72 338.553 504.37 335.977 500 331C496.517 335.013 494.87 338.721 496 344L493 352L489 342C490.704 338.973 493.884 335.047 489 334L489 333L492 332L492 324L488 325L487 320L491 322L493 318L489 319L492 317C491.555 313.791 492.522 310.77 489 310L490 315L489 315L486 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 311L7 317L8 317L9 315L14 317L7 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 311L484 312L483 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 311L493 312L492 311M118.333 312.667L118.667 313.333L118.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M481.667 312.333L482.333 312.667L481.667 312.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 312L498 314L498 313L495 312M488 313L489 314L488 313M117 314L118 315L117 314M263.667 314.333L264.333 314.667L263.667 314.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M464 314L465 315L464 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 314L490 315L489 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496.667 314.333L497.333 314.667L496.667 314.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 314L500 315L499 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M500 314L497 316L502 320L500 318L500 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 317L502 317L501 315L505 320L503 317L505 314L503 317M116.333 315.667L116.667 316.333L116.333 315.667M488 315L489 316L488 315M496 315L496 317L498 315L496 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M504 315L505 316L504 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M470 316L469 324L470 324L472 316L470 316M492 316L489 317L489 318L489 319L492 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M7 317L8 318L7 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M115.333 317.667L115.667 318.333L115.333 317.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 317L488 318L487 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 317L491 318L490 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 317L498 318L497 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M500 317L501 318L500 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 317L505 319L505 317L503 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M460 318L461 322L462 322L462 318L460 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496.333 318.667L496.667 319.333L496.333 318.667M498 318L499 319L498 318M114.333 319.667L114.667 320.333L114.333 319.667M492 319L493 320L492 319M500 319L497 323L497 324L502 325L503 325L503 323L504 325L505 325L500 319M484 320L485 321L484 320M491.333 320.667L491.667 321.333L491.333 320.667M113.333 321.667L113.667 322.333L113.333 321.667M476 321L472 334L476 339L477 339L476 336L476 335L478 335L478 334L475 333L475 329L479 330L476 321M497 321L498 322L497 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M497 323L500 321L497 323M460.333 322.667L460.667 323.333L460.333 322.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M490 322L491 323L490 322M112 323L112 326L113 326L112 323M485 323L486 324L485 323M72 324L72 326L74 326L74 324L72 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M459 328L465 327C462.769 324.178 461.088 325.613 459 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 324L489 325L488 324M492.333 324.667L492.667 325.333L492.333 324.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M462 325L463 326L462 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M468 325L467 330L470 330L468 325M111.333 326.667L111.667 327.333L111.333 326.667M126 327L126 328L130 327L126 327M483 326L483 328L485 328L483 326M491 326L492 327L491 326M500 326L497 328L497 329L500 330L500 326M38 332L55 334L57 328C51.0745 326.593 39.635 324.507 38 332M22 337L30 336C29.877 325.624 21.0508 327.19 22 337M75 328L75 330L79 330L79 328L75 328M110 328L110 331L111 331L110 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M458 328L458 331L459 331L458 328M469 328L470 329L469 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M482 328L483 329L482 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M485 328L486 329L485 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 328L491 331L492 331L491 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M500 328L501 329L500 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M451.333 329.667L451.667 330.333L451.333 329.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 329L486 331L486 330L483 329M487 329L488 330L487 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M64 340C69.0834 337.66 72.5378 335.93 70 330C62.6879 330.471 60.4011 333.014 64 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M473.667 330.333L474.333 330.667L473.667 330.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 331L501 334L502 334L505 332L500 331M109 331L106 348L107 348L109 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451.333 331.667L451.667 332.333L451.333 331.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477.333 331.667L477.667 332.333L477.333 331.667M483 331L484 332L483 331M497.667 331.333L498.333 331.667L497.667 331.333M491 332L492 333L491 332M495 332L496 333L495 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496 332L495 335L496 335L496 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M496 335L499 332L496 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450.333 333.667L450.667 334.333L450.333 333.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M451 333L452 334L451 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M482 333L483 334L482 333M489.667 333.333L490.333 333.667L489.667 333.333M504.333 333.667L504.667 334.333L504.333 333.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 334L451 337L452 337L451 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452 334L451 338L454 338L454 337L452 334M481 334L481 337L482 337L481 334M493 334L493 337L494 337L495 334L493 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M474 335L471 338L474 339L474 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 335L489 336L488 335M447 336L448 337L447 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M448 336L447 338L449 338L448 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M455 336L456 339L457 339L455 336M471.667 336.333L472.333 336.667L471.667 336.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M481 340L485 342L485 338L488 339L487 336L481 340M490 336L491 337L490 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 336L500 338L498 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M499 336L500 338L501 338L502 336L499 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M452 340L456 337L452 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M470 337L471 338L470 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M475 337L472 340L477 340L475 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M477 337L477 340L479 340L479 337L477 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 337L496 338L495 337M501 337L503 339L503 337L501 337M471 338L469 341L469 342C473.253 346.041 474.221 353.178 471 358L471 354L468 359L469 359L469 357L470 357L468 361L474 364L473 366L474 366L475 363L478 365C479.306 361.501 479.411 359.908 477 357L476 357L474 359L475 362L471 359L476 357L474 351L475 347L474 350L473 350L473 342L477 343L478 343C477.308 339.772 475.899 339.98 473 341L471 338M474 338L475 339L474 338M480.333 338.667L480.667 339.333L480.333 338.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M496 338L497 339L496 338M499 338L500 339L499 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 339L455 340L454 339M457 339L457 340L460 341L457 339M490 339L491 340L490 339M501 339L502 340L501 339M446 340L447 343L448 343L446 340M453 340L454 341L453 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M457 340L457 341L459 343C456.347 342.982 457.092 344.906 459 346L457 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 340L488 341L487 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 340L490 341L489 340M494 340L495 341L494 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M496 340L497 341L496 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M501 340L502 341L501 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M23 341L22 342L23 345L26 342L23 341M70 341L71 342L70 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446 341L446 344L447 344L446 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450 341L452 344L450 341M456 341L457 342L456 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M457 341L459 343L459 341L457 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472 341L473 342L472 341M476.333 341.667L476.667 342.333L476.333 341.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 341L504 344L505 344L504 341M455 342L456 343L455 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 342L487 343L486 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 342L491 348L492 348L491 342M495.333 342.667L495.667 343.333L495.333 342.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 342L500 343L499 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 342L500 344L502 342L500 342M459 343L460 344L459 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472 343L473 344L472 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480.667 343.333L481.333 343.667L480.667 343.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 343L485 345L485 343L483 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 343L488 345L490 345L488 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M501 343L500 345L502 345L501 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M71 344L72 345L71 344M458 344L459 345L458 344M494 344L495 345L494 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M497.333 344.667L497.667 345.333L497.333 344.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 345L500 346L503 350L499 350L504 352L505 345L504 344L500 345M457 346L457 347L460 346L461 346L461 349L462 349L461 345L457 346M128 352L134 346C130.127 346.807 128.642 348.059 128 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M460.333 346.667L460.667 347.333L460.333 346.667M473 346L473 350L474 350L473 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477.667 346.333L478.333 346.667L477.667 346.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M482 346L483 349L480 349L481 353L487 356L484 358L490 356L488 356L490 350L485 350L485 349L490 349L490 347L482 346M494.667 346.333L495.333 346.667L494.667 346.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M50 347L51 348L50 347M498 347L499 348L498 347M105 348L105 352L106 352L105 348M492 348L493 349L492 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 348L498 350L500 350L500 348L498 348M503 348L504 349L503 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M490 349L491 350L490 349M458 353L459 353L461 351L458 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M474 350L475 351L474 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M459 351L460 356L457 357L457 358L460 357L458 360L461 361L461 351L459 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M495.333 351.667L495.667 352.333L495.333 351.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 351L498 352L497 351M445 352L446 353L445 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M473 352L471 355L474 356L473 352M482 352L483 353L482 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M483 352L477 358L481 357L484 360L485 356L483 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M484 352L484 357L487 356L484 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M104 353L104 357L105 357L104 353M472 353L473 354L472 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M476.333 353.667L476.667 354.333L476.333 353.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478.667 353.333L479.333 353.667L478.667 353.333M481 353L482 354L481 353M484 353L485 354L484 353M500 353L499 358L500 358L502 353L500 353M503 353L505 355L505 353L503 353M446 354L447 355L446 354M493 354L493 358L494 358L495 354L493 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446 355L448 358L446 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M459 355L460 356L459 355M462 355L464 357L464 355L462 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M470 355L471 356L470 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M457 356L458 357L457 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M471 356L471 358L473 356L471 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 356L483 359L484 359L483 356M496.333 356.667L496.667 357.333L496.333 356.667M446 357L447 358L446 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M458 357L458 359L460 357L458 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M469 357L468 360L469 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 357L481 358L480 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 358L492 359L497 360L496 357L492 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 357L505 358L504 357M103 358L103 361L104 361L103 358M447 358L448 359L447 358M457.333 358.667L457.667 359.333L457.333 358.667M466 358L465 360L467 360L466 358M481 358L482 359L481 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477 359L478 360L477 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 359L489 360L488 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489.333 359.667L489.667 360.333L489.333 359.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 359L494 360L493 359M498 359L499 360L498 359M445.667 360.333L446.333 360.667L445.667 360.333M449 360L453 363L453 362L449 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M473 360L473 362L475 362L475 360L473 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M477 360L477 363L478 363L477 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M491 360L492 361L491 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 360L497 362L497 360L495 360M102 361L102 365L103 365L102 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M445.667 361.333L446.333 361.667L445.667 361.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M459.667 361.333L460.333 361.667L459.667 361.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M471 361L473 363L471 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M482 361L482 362L487 365L488 362L488 361L482 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 361L489 362L491 364L492 364L489 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M493 361L494 362L493 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M445 362L445 369L448 368L449 371L450 371L449 369L450 369L451 373L452 373L453 370L455 376L461 378L459 373L458 363L453 364L453 365L456 364L458 371L454 366L451 368L447 366L445 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M479 362L480 363L479 362M490 362L491 363L490 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 362L493 364L494 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 363L491 370L496 370L497 362L492 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 362L501 364L501 362L499 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M478 363L479 364L478 363M482.667 363.333L483.333 363.667L482.667 363.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M488.667 363.333L489.333 363.667L488.667 363.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450 364L451 365L450 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M454.667 364.333L455.333 364.667L454.667 364.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 364L496 367L497 367L497 364L495 364M499 364L501 367L499 364M101 365L101 369L102 369L101 365M467 365L468 366L467 365M476 365L474 367L474 368L478 369L476 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M479 365L479 366L481 367L479 370L482 368C481.688 370.403 478.923 372.769 477 371L476 371L476 375L479 376C483.553 372.322 487.104 366.191 479 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 365L503 367L505 367L504 365M58 366C52.9965 378.728 75.9155 381.079 78 368L66 372C65.2191 367.307 62.3995 366.61 58 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M452 366L453 367L452 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M15 367L16 368L15 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M489 367L490 368L489 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495.333 367.667L495.667 368.333L495.333 367.667M498 367L499 368L498 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 367L502 369L504 369L503 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M451 368L453 370L453 368L451 368M498 368L501 370L498 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 368L500 369L504 371L500 368M504 368L505 369L504 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M449 369L451 371L449 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M450 369L451 370L450 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M472 369L472 371L474 369L472 369M494 369L495 370L494 369M100 370L100 373L101 373L100 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M452 371L452 372L454 371L453 374L456 371L452 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M454 370L455 371L454 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474.667 370.333L475.333 370.667L474.667 370.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496 370L497 371L496 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497.667 370.333L498.333 370.667L497.667 370.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M62 371L62 372L65 373L62 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M453 371L452 373L454 373L453 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M471 371L470 376L471 376L471 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 371L488 375L489 375L488 373L489 373L492 374C491.346 370.946 489.993 371.064 487 371M495 371L493 374L495 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 371L504 377L504 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M455 372L454 377L455 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M456.333 372.667L456.667 373.333L456.333 372.667M459.667 372.333L460.333 372.667L459.667 372.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 372L475 376L473 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M474 372L475 373L474 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 373L496 374L500 374L496 373M99 373L99 376L100 376L99 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 373L451 374L454 375L451 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 373L485 374L484 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496 374L496 375L500 375L496 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M29 374L23 377C26.0071 385.246 34.0592 380.681 29 374M451 374L453 376L453 374L451 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M455 374L456 375L455 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M502.333 374.667L502.667 375.333L502.333 374.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M459.333 375.667L459.667 376.333L459.333 375.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M482 375L483 376L482 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M485 375L486 376L485 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M485 377L486 378L488 375L485 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 375L497 376L496 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 375L501 376L500 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M82 376L85 379L82 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453 376L454 382L455 382L453 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M466 376L467 377L466 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M482 378L485 376L482 378M492 376L491 382L492 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499.333 376.667L499.667 377.333L499.333 376.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M501 376L501 378L503 378L501 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M98 377L97 383L98 383L98 377M452 377L453 378L452 377M455 377L455 382L456 382L455 377M496.667 377.333L497.333 377.667L496.667 377.333M380 384L375 384L375 387C368.044 384.33 360.251 390.226 354.83 394.349C341.083 404.804 328.944 415.84 324 433L335.004 428.758L350 424.027L372 408L372 407L369 407L369 406L374 404L373 406L374 406L392 400L390 396L401 398L413 390L387 392L387 393L389 394L378 398L378 397L381 396L381 395C369.211 399.548 355.214 414.005 343 414C348.382 408.281 355.794 399.618 364 399L364 398L360 398C369.807 391.339 390.562 390.825 398 381L390 382L392 379C388.267 377.588 380.508 379.791 380 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M392 378L393 379L392 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M392 379L397 381L392 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M396 378L397 379L396 378M448 378L448 379L451 379L448 378M471 378L472 379L471 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472 378L473 379L472 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 378L474 379L473 378M486 378L487 379L486 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496.667 378.333L497.333 378.667L496.667 378.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M67 385L78 384L78 383L77 379C72.3972 379.32 69.4296 381.063 67 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M390 382L397 382C394.625 379.861 390.898 377.896 390 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M397 379L398 380L397 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M448 379L450 383L451 383L451 379L448 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M454.333 379.667L454.667 380.333L454.333 379.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 379L476 380L475 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M477 379L478 380L477 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 379L480 380L479 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486.333 379.667L486.667 380.333L486.333 379.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 379L495 380L494 379M496 379L496 381L498 379L496 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 379L500 380L499 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M501 379L497 382L498 387L502 389L501 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M397 380L398 381L397 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M476 380L477 381L476 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484.333 380.667L484.667 381.333L484.333 380.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M494 380C492.203 386.095 493.715 389.583 499 393L500 387L496 380L494 380M501 380L502 381L501 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M80 381L81 382L80 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M383 381L384 382L383 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M448 381L448 383L450 383L450 381L448 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 381L488 383L490 381L488 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M380.667 382.333L381.333 382.667L380.667 382.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M386 382L388 384L386 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 382L473 385L477 385L475 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M485 382L486 383L485 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 382L488 384L490 384L489 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M504 382L500 390L504 399L505 399L504 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M378.667 383.333L379.333 383.667L378.667 383.333M448 383L449 384L448 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M449 383L450 384L449 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M475 383L476 384L475 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 383L484 384L483 383M485 384L485 385L487 385L485 387L485 388L489 395L490 395L491 391C488.886 389.111 487.822 388.116 490 386L489 388L490 388L491 385L487 383L485 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M491 383L491 387L492 387L491 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492.333 383.667L492.667 384.333L492.333 383.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M499.333 383.667L499.667 384.333L499.333 383.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M500 383L501 384L500 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M96 384L96 389L97 389L96 384M448 384L448 387L449 387L448 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 384L449 391L450 391L450 389L451 389L450 394L451 394L451 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481 384L482 385L481 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 384L485 387L486 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M488 384L489 385L488 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M501 384L502 385L501 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M76 388L76 390C81.3244 391.46 86.2624 389.954 89 385L76 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M373 385L374 387L375 387L376 385L373 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478 385L480 387L480 385L478 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 385L493 386L492 385M498 385L499 386L498 385M500.333 385.667L500.667 386.333L500.333 385.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M38 387L39 392C44.3823 390.364 43.8186 386.021 38 387M403 388L399 387L399 388L400 390L406 386L403 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M406 386L406 387L409 387L406 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M409 386L410 387L409 386M451 386L451 389L452 389L451 386M475 386L476 387L475 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M488.667 386.333L489.333 386.667L488.667 386.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 386L493 390L494 390L492 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M401.667 387.333L402.333 387.667L401.667 387.333M406 387L400 390L401 388L399 390L392 391L392 392L411 391L411 390L406 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M406 388L406 389L412 391C410.38 388.059 409.314 387.501 406 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M410 387L411 388L410 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473.667 387.333L474.333 387.667L473.667 387.333M482 387L483 388L482 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487 387L491 394L492 394L492 388L492 387L487 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 387L496 388L495 387M397 388L398 389L397 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M411 388L412 389L411 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 388L453 390L455 390L455 388L453 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 388L476 389L475 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477 388L477 389L480 389L477 388M481 388L482 389L481 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 388L483 390L485 390L485 388L483 388M490 388L494 394L490 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M395 389L396 390L395 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M397.667 389.333L398.333 389.667L397.667 389.333M450 389L450 392L451 392L450 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M471.333 389.667L471.667 390.333L471.333 389.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 389L493 390L492 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M95 390L94 403L95 403L95 390M393 390L394 391L393 390M475.333 390.667L475.667 391.333L475.333 390.667M478 393L482 392L481 397L482 397L481 395L484 396C483.017 393.05 482.513 392.378 485 393C482.817 390.817 478.869 389.028 478 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 390L489 393L488 390L486 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 390L494 392L496 390L494 390M449 391L450 392L449 391M496 391L497 392L496 391M47 392L46 393L50 397L50 401L40 401L46 410L50 409L52 414L50 413L52 415L52 416L47 413L46 413L43 418C46.7146 418.041 52.3962 420.347 55.7353 418.628C63.3186 414.725 56.6798 407.431 51 407L51 402L57 401L55 397L61 397L49 392L47 392M70.6667 392.333L71.3333 392.667L70.6667 392.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M390 392L391 393L390 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M472 392L472 396L473 396L472 392M476 392L477 393L476 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M478 394L482 392L478 394M490 392L487 395L487 396C490.053 395.867 491.478 394.991 490 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M382 394L382 395L386 394L382 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M378 397L378 398L389 394L378 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M451 393L452 394L451 393M474 393L475 394L474 393M42 394L44 397L44 394L42 394M63 394L65 401L57 402L57 403L67 404L67 394L63 394M470 394L471 395L470 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M357 395L358 396L357 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452.333 395.667L452.667 396.333L452.333 395.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 395L475 399L478 395L475 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M481.667 395.333L482.333 395.667L481.667 395.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486 395L487 396L486 395M500 395L499 397L501 397L500 395M478 396L480 398L478 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M480 396L478 397L478 410L482 413L479 412L484 414L484 418L485 418L482 401L486 401L486 400L480 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M490 396L491 397L490 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 405L487 403L487 408L489 407C490.948 410.171 492.368 410.823 496 410L496 409L493 408L496 398C490.093 395.922 488.814 399.801 490 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 397L451 399L453 399L453 397L451 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 397L474 398L473 397M484 397L484 400L485 400L486 397L484 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M500 397L501 398L500 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M72 398L73 399L72 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M373 399L373 400L378 399L373 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M397 402L397 403L409 399C404.681 397.332 400.758 399.818 397 402M469 398L469 400L471 398L469 398M472 398L473 399L472 398M477 398L478 399L477 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491 398L491 401L492 401L493 398L491 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 398L501 399L500 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M501 398L501 401L503 401L503 398L501 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M406 399L400 403L393 405L393 406C398.161 405.893 404.741 405.426 408 401L405 402L406 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M405 402L409 402L408 399L405 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M409 399L411 402L409 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452 399L451 403L452 403L455 401L452 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M454 399L455 400L454 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474 399L475 400L474 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497.667 399.333L498.333 399.667L497.667 399.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M28 401L30 406L27 409C30.6127 409.526 36.3353 414.567 39.7708 413.268C47.223 410.449 32.3323 400.385 28 401M410 400L411 401L410 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M453 400L454 401L453 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M50 401L51 402L50 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M89.3333 401.667L89.6667 402.333L89.3333 401.667M411 401L388 407L389 410L377 415L377 414L382 412L382 411L353 432L353 433C360.989 431.888 365.732 426.266 372.209 422.224C375.762 420.007 380.232 419.675 384 417.821C387.903 415.9 392.076 414.768 392 410C398.251 411.488 415.309 411.685 411 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M452.333 401.667L452.667 402.333L452.333 401.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453 401L451 406L453 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M469 401L469 404L469 405L473 406L474 403L469 401M482.333 401.667L482.667 402.333L482.333 401.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496 401L498 403L496 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 401L500 402L499 401M504 401C503.275 404.568 501.932 407.504 505 410L504 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M368 402L369 403L368 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M399 402L400 403L399 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478.333 402.667L478.667 403.333L478.333 402.667M70 403L70 404L76 404L70 403M93 403L93 409L94 409L93 403M395 403L396 404L395 403M454 403L455 404L454 403M483 403L484 404L483 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M492 403L492 405L494 403L492 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499.333 403.667L499.667 404.333L499.333 403.667M501 403L502 404L501 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M364 404L365 405L364 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M393.667 404.333L394.333 404.667L393.667 404.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M410 404L404 407L404 408L410 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M471 404L472 405L471 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 406L478 404L475 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M486 405L487 406L486 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 405L501 406L500 405M81 406L79 410L82 417L78 416L80 412L71 413L76 419L82 418L76 421L76 423L82 424L82 425L74 426L74 427L78 428L77 431L80 431L79 428L86 426L84 423C86.3604 422.95 92.317 419.97 88 420L89 417L88 416L83 416L83 415L91 410L92 410L92 415L93 415C92.8004 408.922 90.659 408.349 85 409L85 406L81 406M451 406L453 412L454 412L451 406M478 406L479 407L478 406M482 406L483 407L482 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497.333 406.667L497.667 407.333L497.333 406.667M499 406L499 409L501 408L501 407L499 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M34 407L34 410L36 409L36 408L34 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M389.667 407.333L390.333 407.667L389.667 407.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474 407L475 408L474 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M482 407L483 408L482 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 407L484 408L483 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 408L9 411L9 412L9 413L7 415L13 414C12.3522 410.078 10.7637 409.015 7 408M172 410C172.645 415.962 171.885 421.973 178 425L178 426L168 426C171.479 430.169 175.6 432.346 181 431L182 432C179.016 436.984 181.011 447.651 187.148 450.243C191.691 452.161 197.505 449.112 202 448.39C205.352 447.851 208.742 449.794 211.941 449.072C217.687 447.775 219.797 436.732 219 432L235 420L235 417C214.656 411.988 192.633 406.507 172 410M386 408L383 410L383 411L387 409L386 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M377 414L377 415C381.977 414.376 386.515 412.501 389 408L377 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453.333 408.667L453.667 409.333L453.333 408.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 408L480 409L479 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M39 409L39 412L40 412L39 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M43.3333 409.667L43.6667 410.333L43.3333 409.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M452 410L453 415L454 415L452 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473.333 410.667L473.667 411.333L473.333 410.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M476 410L476 412L478 412L476 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M484 410L485 411L484 410M501 410L502 411L501 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M502.333 410.667L502.667 411.333L502.333 410.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M354 411L355 412L354 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481.333 411.667L481.667 412.333L481.333 411.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499.667 411.333L500.333 411.667L499.667 411.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486 412L488 414L486 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M487 412L489 414L489 412L487 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 412L493 413L492 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M503 412L504 413L503 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M186 421L192 423L192 424L187 426L187 427L205 427L205 431L204 431L202 428L200 433L201 433L203 431L201 434L201 435L209 431L206 426C211.98 425.598 215.293 423.234 214 417C204.607 418.192 189.706 408.849 186 421M352 413L347 415L347 416L353 414L352 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M471 413L473 415L471 413M475 413L476 414L475 413M489.333 413.667L489.667 414.333L489.333 413.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 413L493 414L492 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 414L495 418L496 418L495 415L501 414L493 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M476 414L477 415L476 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 414L480 415L484 416L480 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M375.667 415.333L376.333 415.667L375.667 415.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M453 415L454 416L453 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 415L453 419L454 419L454 415M475 415L476 416L475 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M487 415L488 416L487 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 415L489 416L488 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M491 415L492 416L491 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493.333 415.667L493.667 416.333L493.333 415.667M495 415L498 417L495 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M501 415L502 416L501 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M503 415L503 417L505 417L503 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M30 416C28.7815 420.16 28.6368 423.246 33 425L33 426L31 432L25 432L25 434C31.4078 435.811 38.8413 434.245 45 432C41.929 421.641 42.2576 416.988 30 416M91 416L91 419L92 419L93 416L91 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453.333 416.667L453.667 417.333L453.333 416.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M470 416L471 417L470 416M472.667 416.333L473.333 416.667L472.667 416.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477 416L481 419L481 418L477 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478 416L479 417L478 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M480 416L481 417L480 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M482 416L483 417L482 416M484 416L485 417L484 416M487 416L490 420L491 418L491 417L487 416M22 417L23 427L25 427C27.5852 422.222 28.3933 418.044 22 417M383 430L394 426L400 421C395.665 413.248 384.9 424.572 383 430M474 417L475 418L474 417M483 417L484 418L483 417M485 417L486 418L485 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M488 417L489 418L488 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 417L492 419L494 419L494 417L492 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M501 418L504 420L503 417L501 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M40 423C34.7988 413.121 27.2467 426.728 40 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M218.667 418.333L219.333 418.667L218.667 418.333M396.667 418.333L397.333 418.667L396.667 418.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481.667 418.333L482.333 418.667L481.667 418.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 418L490 419L489 418M24.3333 419.667L24.6667 420.333L24.3333 419.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 419L474 420L473 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 419L477 421L477 419L475 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M485 419L486 420L485 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493.333 419.667L493.667 420.333L493.333 419.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M495 419L496 420L495 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 419L500 420L499 419M504 419L505 420L504 419M61.3333 420.667L61.6667 421.333L61.3333 420.667M69 420L70 422L71 422L72 420L69 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M219 420L219 422L224 422L224 420L219 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M236 420L237 421L236 420M474 420L475 421L474 420M480 420L480 421L486 421L483 422L484 420L480 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M481.667 420.333L482.333 420.667L481.667 420.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 420L503 421L502 420M12 421L16 423L12 421M239 421L240 422L239 421M453 421L453 423L455 423L453 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M483 421L484 422L483 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 422L487 423L491 427L492 427L491 421L487 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 421L494 422L493 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497 424L500 421L497 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M501 421L502 422L501 421M503 421L504 422L503 421M63 428C74.2115 427.211 64.6234 417.822 63 428M474 422L475 423L474 422M477.333 422.667L477.667 423.333L477.333 422.667M233 423L234 424L233 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M234 423L234 424L239 424L234 423M453.667 423.333L454.333 423.667L453.667 423.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 423L476 424L475 423M480 423L480 425L482 423L480 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M481 424L488 426C486.08 423.043 484.304 423.117 481 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 426L502 425L495 428L498 432L494 434L494 435L498 434L497 436L498 436L503 435L497 429L501 431L502 427L503 427L504 432C505.782 426.98 501.578 421.741 497 426M502 423L503 424L502 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M66 424L65 426L67 426L66 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M91 424C91.9677 432.44 87.8465 433.934 80 434L81 437L78 437L79 434L53 438L53 436L48 437L54 448L65 447L66 450L64 455L66 455C67.5929 449.977 70.2288 445.457 75 443L71 448L77 448L77 449L72 451L72 452L79 452L78 458L73 458L73 457L77 455C74.0787 454.693 70.4817 454.757 70 458L63 456C64.6777 460.502 60.778 462.836 59 458L46 457L50 463L47 464L47 466L56 469L49 484L54 482L51 485L51 486L56 487L54 491L59 496L62 494L71 495L67 500L63 499C63 502.617 55.9671 500.835 53 501C44.5212 501.471 36.0563 501.449 38 512L46 512L45 506L52 503L52 511L52 512L69 512L69 511L67 510L75 509L75 512L78 510C83.5898 511.744 99.8548 514.737 104 510L105 510L106 510L120 512C115.984 506.059 108.627 503.218 105.279 496.996C94.0711 476.17 93 447.044 93 424L91 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M231 424L230 426L231 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M224 435L225 435C229.385 429.265 233.371 427.267 240 425C232.302 421.778 226.087 427.977 224 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M240 424L239 426L241 426L240 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 424L489 425L488 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493.333 424.667L493.667 425.333L493.333 424.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494.333 424.667L494.667 425.333L494.333 424.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M495 424L495 426L497 426L497 424L495 424M498 427L502 425L498 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M48 425L49 426L48 425M89 425L90 426L89 425M229 425L230 426L229 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M246 425L239 448L240 448L251 435C247.984 434.597 248.634 432.701 249 430L250 432L251 432L246 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M476 425L476 426L479 426L476 425M482 425L483 426L482 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M34 426L35 427L34 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M228 426L229 427L228 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M234.667 426.333L235.333 426.667L234.667 426.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M372 461L368 449L367 449L368 453L355 448L355 447L362 443L367 448C361.793 436.958 344.559 438.001 334 438L334 439L347 440C343.63 448.119 336.172 445.275 329 446L331 443L324 446L323 446C325.116 441.062 327.641 439.175 333 439C326.877 436.425 318.604 437.539 312 436.925C301.392 435.939 290.329 433.844 280 431.255C275.076 430.02 265.203 424.557 260.318 426.644C255.171 428.842 259.868 446.132 262.724 449.2C268.729 455.651 275.211 455.124 283 457.043C290.606 458.917 296.897 462.451 305 462.428C317.49 462.393 329.059 457.587 341 457.039C351.915 456.539 361.433 460.752 372 461M474 426L474 429L476 426L474 426M484 426L488 429L488 428L484 426M487 426L488 427L487 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M227 427L228 428L227 427M230 429L233 428L230 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M234.333 427.667L234.667 428.333L234.333 427.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M247 427L249 429L247 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478 427L478 428L478 429L483 431L483 430L478 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M480 427L481 428L480 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M502 427L503 428L502 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M46 430L47 433L53 428L46 430M226 428L227 429L226 428M231 428L232 429L231 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M241 428L235 430L237 435L228 434C226.072 439.547 229.222 443.065 235 442L238 444L243 428L241 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M479.333 428.667L479.667 429.333L479.333 428.667M485 428L487 433L484 434L484 435C488.053 433.654 488.65 430.374 485 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 428L491 429L490 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 428L494 429L493 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M494 428L496 431L494 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M502 428L500 432L504 432L502 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M62 430L62 431L73 430L62 430M225 429L226 430L225 429M229 429L230 430L229 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492.333 429.667L492.667 430.333L492.333 429.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M497 429L500 432L497 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M225 430L226 431L225 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M228 430L229 431L228 430M230 431L230 432L235 431L230 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M249 430L249 436L250 436L249 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 430L474 431L473 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 430L477 434L475 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M485 430L486 431L485 430M7 431L8 432L7 431M224 431L225 432L224 431M227 431L228 432L227 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M237 431L239 433L237 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M243 431L244 432L243 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M332 431L333 432L332 431M470 431L470 432L473 432L470 431M488.333 431.667L488.667 432.333L488.333 431.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496 431L496 433L498 431L496 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M224 432L225 433L224 432M226.333 432.667L226.667 433.333L226.333 432.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477 432L477 433L482 435L482 434L477 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 432L481 433L480 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M482 432L483 433L482 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486 432L487 433L486 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 432L500 433L505 433L500 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M228 433L229 434L228 433M464 433L466 436L464 433M469.667 433.333L470.333 433.667L469.667 433.333M472 433L472 434L475 437L476 437L477 434L472 433M484 433L485 434L484 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 433L494 437L490 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M498 433L499 434L498 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M501 433L501 434L504 434L501 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 433L505 434L504 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M210 438L216 438L216 434L210 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M225 434L224 437L225 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M229 434L230 435L229 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M242 434L243 435L242 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M246 434L245 438L246 438L246 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M467 434L468 435L467 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M469 436L474 435L469 436M475 434L476 435L475 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 434L481 435L480 434M483 434L484 435L483 434M487 434L488 435L487 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M496.667 434.333L497.333 434.667L496.667 434.333M65 440L70 440L69 435L65 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M468 435L468 438L469 438C471.64 437.12 471.566 436.734 471 439L472 439L473 435L468 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472 437L475 435L472 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 435L501 436L500 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M502 435L503 436L502 435M84 436L84 438L86 438L84 436M88 437L89 442L90 442L92 436L88 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M226 436L227 437L226 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M241.333 436.667L241.667 437.333L241.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M248 436L247 439L248 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481 436L481 439L482 439L481 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M482 436L482 440L483 440L482 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 436L483 440L484 440L483 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 436L486 437L490 437L486 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M496.667 436.333L497.333 436.667L496.667 436.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499.333 436.667L499.667 437.333L499.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502.333 436.667L502.667 437.333L502.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504.333 436.667L504.667 437.333L504.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M54 440L56 445C62.2179 441.272 61.0814 435.912 54 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M224 437L225 438L224 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M230.667 437.333L231.333 437.667L230.667 437.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M469 439L472 437L469 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 437L480 438L479 437M486.333 437.667L486.667 438.333L486.333 437.667M488.667 437.333L489.333 437.667L488.667 437.333M35 441L39 440L34 444L36 447L37 447L49 446L49 445L43 444L43 443L47 443L47 441C42.9183 440.914 36.2414 435.207 35 441M43.6667 438.333L44.3333 438.667L43.6667 438.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M323 446L324 446L331 443L329 446C335.953 445.874 344.678 448.407 347 440C338.562 439.334 325.881 435.053 323 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M457 438L458 439L457 438M464 438L463 440L465 440L464 438M501 438L499 441L504 439L501 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M63.3333 439.667L63.6667 440.333L63.3333 439.667M207 439L208 440L207 439M215 439L216 440L215 439M494 439L495 440L494 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 439L496 440L495 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M244.667 440.333L245.333 440.667L244.667 440.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M487 440L487 441L491 442L491 441L487 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M492 440L493 441L492 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 440L495 444L499 444L499 443L497 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 440L497 443C499.158 442.022 499.501 441.812 498 440M501 440L502 441L501 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M32 441L33 442L32 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M205 441L206 442L205 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M228 441L228 444L229 444L228 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M483 441L484 442L483 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 441L488 444L489 441L486 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 441L505 442L504 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M7 442L8 443L7 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M7 445L13 447L7 446L7 458L18 458L19 457L19 455L18 454L13 455L13 454L17 452L14 451C14.8557 446.092 11.6559 438.499 7 445M463 442L463 444L465 444L465 442L463 442M474 442L471 443L471 444L474 444L474 445L472 446L473 447L474 442M476 442L477 443L476 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M476 443L482 445L476 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 442L492 443L491 442M19 443C20.5308 447.595 23.8901 446.817 26 443L19 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M348 443L348 445L350 445L350 443L348 443M353 443L354 444L353 443M361 443L355 447L355 448L368 453L361 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M460.667 443.333L461.333 443.667L460.667 443.333M467 443L467 445L469 445L469 443L467 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M474 443L475 444L474 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M488 443L486 444L486 445L488 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M489 443L490 444L489 443M492 443L492 445L494 445L494 443L492 443M501.333 443.667L501.667 444.333L501.333 443.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 443L505 444L504 443M32 444L33 445L32 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M59 444L59 446L65 445L59 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M237.667 444.333L238.333 444.667L237.667 444.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M460 444L460 447L461 447L460 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M461 444L461 448L462 448L461 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M472 444L473 445L472 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M473 444L474 445L473 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M484 444L485 445L484 444M499 444L501 446L499 444M503 444L504 449L503 444M229 445L229 446L233 446L233 445L229 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M231 445L232 446L231 445M232 446L236 448L232 446M462 445L461 449L456 448L456 453C459.136 451.08 463.392 449.129 462 445M468 445L471 448L468 445M474 445L472 453L478 450L474 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 445L479 446L483 446L479 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M483 445L485 447L485 445L483 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 445L491 449L500 450C499.291 443.44 494.39 447.373 491 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M499 445L500 446L499 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M238 446L236 447L236 448L238 446M463 446L464 447L463 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493 448C495.396 448.575 495.487 448.475 496 446L493 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M45 448C47.35 451.293 50.1192 451.421 54 451L54 449L45 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M92 447L93 448L92 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M233 447L234 448L233 447M457 447L457 448L461 449L457 447M468 447L471 449C470.873 452.377 471.523 453.825 475 454L472 453L474 449L468 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M474 447L475 448L474 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M476.667 447.333L477.333 447.667L476.667 447.333M487 447L488 448L487 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 447L497 449L499 449L498 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M8 448L10 455L8 448M88 448L85 450L85 451L89 451L88 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M457 448L458 449L457 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M464 448L466 452L464 448M478 450L481 449L478 450M485 448L486 449L485 448M489 448L490 449L489 448M41 450L41 451L45 451L41 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M92.3333 449.667L92.6667 450.333L92.3333 449.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M455 449L456 450L455 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M461 449L461 451L463 451L463 449L461 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M463 449L463 452L464 452L463 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M479 449L481 451L481 449L479 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M487 449L489 451L489 449L487 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 449L491 450L490 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M496 449L497 450L496 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 449L504 452L505 452L504 449M31 450L22 453C24.6388 457.007 32.9434 454.641 31 450M459 450L462 453L459 450M484 450L487 452L487 451L484 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 450L503 453L504 452L500 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M56 451L60 455L60 452L56 451M458 451L457 457L458 457L458 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M461.667 451.333L462.333 451.667L461.667 451.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M491 451L488 458L493 455L490 456L493 454L491 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M493 451L491 460L494 461L493 463L499 464L494 458L497 458L497 457L493 451M498 451L500 453L500 451L498 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451.667 452.333L452.333 452.667L451.667 452.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 454L457 454L456 452L454 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M457.333 452.667L457.667 453.333L457.333 452.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481 452L482 453L481 452M487 452L486 454L488 454L487 452M76 453L77 454L76 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M80 453L81 454L80 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M451.667 453.333L452.333 453.667L451.667 453.333M497.667 453.333L498.333 453.667L497.667 453.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M90.3333 454.667L90.6667 455.333L90.3333 454.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M455 457L458 454L455 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 454L476 455L475 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 456L493 455L490 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 454L500 455L499 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M501 454L502 455L501 454M34.6667 455.333L35.3333 455.667L34.6667 455.333M39 458L43 455L39 458M52 455L52 456L55 456L52 455M468 455L465 462L466 463L468 463L471 457L471 456L468 455M472 455L473 456L472 455M484.667 455.333L485.333 455.667L484.667 455.333M498 455L495 458L496 462L497 462L498 457L499 459L500 459L498 455M504 455L505 456L504 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M469 456L469 463L472 463L472 458L471 458L471 460L470 460L469 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473 456L474 457L473 456M480.667 456.333L481.333 456.667L480.667 456.333M483 456L484 457L483 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 456L490 457L489 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500.333 456.667L500.667 457.333L500.333 456.667M502 456L503 457L502 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M59 457L60 458L59 457M455 457L456 458L455 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M460.333 457.667L460.667 458.333L460.333 457.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M461 457L463 461L461 457M471 457L473 459L473 457L471 457M477 457L478 458L477 457M482 457L483 458L482 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 457L488 458L487 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 457L499 458L498 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M503 457L504 458L503 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 457L505 458L504 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M83 459L83 460L89 458L83 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456 458L455 459L459 464L461 463L456 458M470.333 458.667L470.667 459.333L470.333 458.667M475 458L476 459L475 458M479 458L480 459L479 458M483 458L485 460L483 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M484 458L487 462L484 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M494 458L495 459L494 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M498 459L501 464L502 464L503 458L498 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M21 459L21 460L24 461L21 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M67 459C67.8286 462.867 70.8127 462.165 74 461L67 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M472 459L473 460L472 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477 459L478 460L477 459M480 459L481 460L480 459M486.333 459.667L486.667 460.333L486.333 459.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M457 460L457 462L459 462L459 460L457 460M466 460L466 462L468 462L468 460L466 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M472.333 460.667L472.667 461.333L472.333 460.667M481 460L482 461L481 460M490 460L489 465L493 466L490 460M504 460L505 461L504 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M50 465L50 466L58 465L61 469L62 463L50 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M452 461L455 468L452 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 461L476 462L475 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M491 461L492 465L493 465L491 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492 461L493 462L492 461M503 461L504 462L503 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M479 462L480 463L479 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M486 462L487 463L486 462M488 462L489 463L488 462M504 462L505 463L504 462M32 463L36 476L38 476L39 475L38 472L40 467L35 468L35 463L32 463M55 463L56 464L55 463M191 468L197 466L197 464L196 463L191 468M469 463L469 464L472 464L469 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M489 463L490 464L489 463M500 463L501 464L500 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M10 475L7 478L13 477L8 470C11.8051 469.178 12.9753 467.714 14 464C7.71884 464.442 4.17396 470.798 10 475M43 464L43 465L46 465L43 464M460 464L462 467L460 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M461.333 464.667L461.667 465.333L461.333 464.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M465 464L471 469L471 465L465 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M469.333 464.667L469.667 465.333L469.333 464.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475.667 464.333L476.333 464.667L475.667 464.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M487 464L487 466L489 466L487 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 464L501 465L500 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502 464L503 465L502 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504.333 464.667L504.667 465.333L504.333 464.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M67 466L55 472C56.0154 476.453 58.5091 489.597 63.2747 491.303C66.371 492.412 70.6054 490.488 74 491L68 488L74 484L74 483L69 482L69 480L77 478L73 479L72 475L77 476C77.989 467.418 75.2162 465.38 67 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M477 465L476 470L477 470L478 470L477 465M480 465L480 466L480 467L483 467L483 466L480 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 465L485 466L484 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M450 466L451 476L452 476L452 473L455 474L455 473L452 466L450 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M481 466L482 467L481 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M494.667 466.333L495.333 466.667L494.667 466.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 466L499 467L498 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474 467L475 468L474 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M479 467L479 473L480 473L479 467M484 467L487 471L487 483L490 481L492 488L490 495L487 493L493 498L491 492L494 494L493 480L488 468L484 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M496 470L501 469L504 472L504 468L496 470M504 467L505 468L504 467M43.6667 468.333L44.3333 468.667L43.6667 468.333M47 473L37.9105 477.188L28 475L27 481L39 483L39 484L36 487L24 483C23.5791 488.517 21.0198 489.637 16 491L18 493L17 497L10 497L11 500L8 493L12 484L7 483C7 489.976 4.81219 503.444 9 509L9 510L7 512L11 512C12.201 504.308 18.5531 506.542 23 502L32 504L31 502C33.4525 502.064 50.8973 496.721 46 494L46 493L53 491L53 490L47 486L48 483L42 483L47 480L47 479L52 469C48.7494 469.134 47.9483 469.898 47 473M221 468L222 469L221 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453 468L455 470L455 468L453 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456 468L457 469L456 468M458 468L458 472L459 472L458 468M466 468L466 470L468 468L466 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477 468L478 469L477 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 468L490 472L491 472L489 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 468L491 469L490 468M498 468L499 469L498 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 469L454 470L453 469M482 469L483 470L482 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M494 469L495 470L494 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M27 472L30 470L27 472M454 470L455 471L454 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477.333 470.667L477.667 471.333L477.333 470.667M482.667 470.333L483.333 470.667L482.667 470.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M484.667 470.333L485.333 470.667L484.667 470.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M491.667 470.333L492.333 470.667L491.667 470.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M450 471L451 472L450 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474.333 471.667L474.667 472.333L474.333 471.667M476 471L477 472L476 471M483 471L483 472L486 472L483 471M497 471L498 472L497 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M48 472L49 473L48 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M56 474L57 475L59 472L56 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 472L452 473L451 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 472L493 478L494 478L492 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M499 472L498 475L501 473L499 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504.333 472.667L504.667 473.333L504.333 472.667M469 473L473 477L469 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M479 474L481 476L479 481L484 482L482 473L479 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 473L503 474L502 473M236 474L236 475L239 475L236 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M471.333 474.667L471.667 475.333L471.333 474.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M474.333 474.667L474.667 475.333L474.333 474.667M476 474L476 475L476 476L479 476L479 475L476 474M467 475L467 481L468 481L469 475L467 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M477.333 475.667L477.667 476.333L477.333 475.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M483 475L484 476L483 475M494 475L495 476L494 475M496 475L497 476L496 475M501.333 475.667L501.667 476.333L501.333 475.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M79 476L80 477L79 476M88 476L89 477L88 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 476C497.513 478.475 497.604 478.575 500 478L497 476M459.667 477.333L460.333 477.667L459.667 477.333M469 477L470 478L469 477M492 477L492 479L494 479L492 477M502 477L503 478L502 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M29 480L32 478L29 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M47 478L48 479L47 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M78 478L75 486L80 484L81 487L77 488L77 489L82 491C81.9994 485.672 82.3174 481.654 78 478M92 478L87 480L87 481L93 479L92 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 478L476 479L475 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M495 478L495 480L497 480L495 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 479L448 481L450 481L448 479M476 479L474 483L479 482L476 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M489 479L490 480L489 479M492 479L493 480L492 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493 479L494 480L493 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503.333 479.667L503.667 480.333L503.333 479.667M16 480L16 481L19 481L16 480M470 480L469 485L470 485L471 483L472 486C473.587 483.088 472.652 481.764 470 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M485 480L486 481L485 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M493 480L497 485L493 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497 480L499 486L500 486L497 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M500 480L501 481L500 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M501 480L502 481L501 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M85 481L86 482L85 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M489 481L487 484L489 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M495 481L496 482L495 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 481L502 482L502 483L504 481M80 482L81 483L80 482M451 482L452 486L453 486L451 482M459 482L460 483L459 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M460 482L460 486L461 486L460 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M465 482L465 486L468 485L465 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 482L478 484L475 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M481 482L480 493L483 490C480.746 487.611 481.673 484.98 484 483L485 488L488 488L488 489L484 489L485 494L486 494L487 491L489 493L487 483L481 482M461 483L461 486L460 486L460 484L459 484L460 488L461 488L461 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M482 483L481 490L485 492L484 483L482 483M485 483L486 484L485 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M489 483L490 484L489 483M64 484L65 485L64 484M445 484L445 485L449 486L445 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M486 484L487 485L486 484M488 484L489 488L490 488L488 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M490 484L491 488L492 488L490 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 484L500 485L503 485L500 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M473.333 485.667L473.667 486.333L473.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 485L478 489L475 485M467 486L468 487L467 486M474 486L475 487L474 486M495.667 486.333L496.333 486.667L495.667 486.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500.333 486.667L500.667 487.333L500.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M503 486L504 491L505 491L503 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M47 487C46.1456 489.697 46.1492 490.386 49 491L47 487M74 487L75 488L74 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 487L455 488L454 487M456 487L456 488L458 490L459 490L456 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M475 487L476 488L475 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M485 489L488 489L487 487L485 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M490 487L491 488L490 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M495 487L495 494L496 494L495 491L499 491L495 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498.333 487.667L498.667 488.333L498.333 487.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502.333 487.667L502.667 488.333L502.333 487.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M13 488L14 491L13 488M445 488L447 490L447 488L445 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M456 488L455 493L463 492L460 493L458 488L456 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M465 488L465 489L469 489L465 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M489.333 488.667L489.667 489.333L489.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M80 489L81 490L80 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M457 489L458 490L457 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M469 489L470 490L469 489M472 489L473 490L472 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M478 489L478 493L479 493L478 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 489L495 490L494 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M27 490L28 491L27 490M42.6667 490.333L43.3333 490.667L42.6667 490.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M480 490L481 491L480 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M495 491L495 492L498 491L495 494L495 495L499 493L498 496L501 494L501 493L498 490L495 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M29 491L29 493L34 492L29 491M87 495L92 495L91 493L96 492C92.1496 490.462 88.3671 490.784 87 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M449 491L451 496L451 491L449 491M455 491L456 492L455 491M459 491L460 492L459 491M461 491L461 492L471 495L470 498L471 498L470 491L461 491M477 491L478 492L477 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487.333 491.667L487.667 492.333L487.333 491.667M497 491L496 494L497 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M500 491L501 492L500 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M19 492L20 493L19 492M39 492L37 496L43 497L39 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M456 492L457 496L458 496L456 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M460 492L461 493L460 492M471.667 492.333L472.333 492.667L471.667 492.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M489 492L490 495L489 492M491 492L491 494L493 494L491 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M455 493L456 494L455 493M462 493L463 494L462 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M484 493C483.394 497.027 485.214 498.173 489 499L484 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M498 493L497 495L499 495L498 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 494L505 497L505 493L502 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M73.3333 494.667L73.6667 495.333L73.3333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M445 496L448 495L445 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M450 494L451 495L450 494M456 494L457 495L456 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M458 494L459 495L458 494M492.333 494.667L492.667 495.333L492.333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M25.6667 495.333L26.3333 495.667L25.6667 495.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M441 495L441 496L444 496L444 495L441 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446 495L446 497L448 497L448 495L446 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M456 495L455 499L456 499L456 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M458 495L456 500L458 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M465 495L463 499L467 501L465 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M470 495L471 496L470 495M493 495L493 497L495 497L493 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M501 495L502 496L501 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M440 496L442 498L442 496L440 496M450 496L451 497L450 496M465.333 496.667L465.667 497.333L465.333 496.667M492 496L493 497L492 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M494 498L497 496L494 498M437 499L437 500L440 502L442 498L437 499M446 497L447 498L446 497M450 497L450 501L451 501L450 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M455 497L456 498L455 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M459 497L458 498L458 500L462 503L461 497L459 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M475.333 497.667L475.667 498.333L475.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M500 497L501 498L500 497M502 497L503 498L502 497M61 498L62 499L61 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M439 498L440 499L439 498M446 498L448 500L448 498L446 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M473.667 498.333L474.333 498.667L473.667 498.333M476 498L476 500L478 500L476 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M487 498L488 499L487 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M490 498L492 500L490 498M498 498C496.446 500.21 496.726 500.586 499 502L498 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M72 499L72 500L80 503L72 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M440 499L441 500L440 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M446 499L446 501L448 501L446 499M469 499L472 504L471 502L474 503L473 500L469 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M473 499L474 500L473 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M474 499L474 502L477 501L477 500L474 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M480 499L480 500L483 503L489 502L488 499L480 499M495 499L492 500L490 504L497 503L497 502L494 503L495 499M457 500L458 501L457 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M470.333 500.667L470.667 501.333L470.333 500.667M477 500L474 502L474 503L477 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M446.667 501.333L447.333 501.667L446.667 501.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M478 501L479 502L478 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M484 501L485 502L484 501M487 501L488 502L487 501M494 501L494 503L496 501L494 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M502 501C501.785 504.859 502.341 509.141 498 510C501.256 513.263 505.446 508.646 503 505L505 502L503 503L504 501L502 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M65 502L66 503L65 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M69.6667 502.333L70.3333 502.667L69.6667 502.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M446 502L445 510L448 509L450 510L454 512L451 509L452 504L446 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M447 502L448 503L447 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M448 502L449 503L448 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M453 502L453 505L455 504L455 503L453 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M454 502L455 503L454 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M456 502L457 503L456 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M476.667 502.333L477.333 502.667L476.667 502.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M489 502L490 503L489 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M45 506L46 512L54 511L52 503L45 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M54 503L56 511L57 511L59 508L59 507L54 503M57.6667 503.333L58.3333 503.667L57.6667 503.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M79 505C81.8991 506.02 83.3084 506.228 84 503L79 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M447 503L448 504L447 503M458 503L458 504L462 504L458 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M467 503L468 504L467 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M470 503L471 512L479 512L478 509L470 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 503L476 504L475 503M487 503C483.207 505.608 481.661 508.273 485 512L484 507L490 512L492 510L495 512L495 511L492 508L495 510L496 510L495 506L492 507L490 510L487 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492 503L493 508L494 508L496 505L492 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M499 503L499 505L501 505L501 503L499 503M441 504L441 506L443 506L443 504L441 504M454 504L455 505L454 504M456 504L457 505L456 504M458 504L459 511L462 504L458 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M460 504L461 505L460 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M468.333 504.667L468.667 505.333L468.333 504.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M475 504L476 505L475 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M475 505L475 506L479 508L480 505L478 504L475 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M478.333 504.667L478.667 505.333L478.333 504.667M483.333 504.667L483.667 505.333L483.333 504.667M487 504L488 505L487 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M492.333 504.667L492.667 505.333L492.333 504.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M501 504L499 511C501.715 509.241 502.277 507.013 501 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M503 504L505 506L505 504L503 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M39 505L43 509L43 505L39 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M64.6667 505.333L65.3333 505.667L64.6667 505.333M91 505L92 506L91 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M438.333 505.667L438.667 506.333L438.333 505.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M450 505L451 506L450 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M453 505L456 511L456 507L453 505M470 505L470 512L471 512L470 505M473 505L475 508L473 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M77 506L78 507L77 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M88.6667 506.333L89.3333 506.667L88.6667 506.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M434 506L436 508L436 506L434 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M476 506L476 508L478 508L478 506L476 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 506L499 507L498 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M503 506L504 507L503 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M484 507L485 512C488.054 511.346 487.936 509.993 488 507L484 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M490 507L490 510L491 510L490 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M497 507L498 508L497 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M60 508L61 509L60 508M102 508L103 509L102 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M430 512L431 512L432 510L438 512L437 509L444 512L442 508L430 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M451 508L452 509L451 508M455 508L456 509L455 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M479 508L479 512L480 512L479 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M492.333 508.667L492.667 509.333L492.333 508.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M498 508L499 509L498 508M18 512L22 512L21 509L18 512M26 511L29 509L26 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M64 509L65 510L64 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M67 510L67 511L75 512L75 509L67 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M98 509L99 510L98 509M437 509L441 512L437 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M441 509L442 510L441 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M450 509L451 510L450 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M476 509L477 510L476 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M488 509L490 512L488 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M497 509L498 510L497 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M504 509L501 511L501 512L504 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M31 511L31 512L36 512L31 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M78 510L78 511L82 512L78 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d49f19",
      stroke: "none"
    },
    d: "M93 511L93 512L97 512L93 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M104 510L104 512L106 512L106 510L104 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M431.333 510.667L431.667 511.333L431.333 510.667M441 510L442 511L441 510M449.333 510.667L449.667 511.333L449.333 510.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M472.667 510.333L473.333 510.667L472.667 510.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M491.333 510.667L491.667 511.333L491.333 510.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M59 511L60 512L59 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82a596",
      stroke: "none"
    },
    d: "M455 511L456 512L455 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M461.667 511.333L462.333 511.667L461.667 511.333M466.667 511.333L467.333 511.667L466.667 511.333M474.667 511.333L475.333 511.667L474.667 511.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M481 511L482 512L481 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252323",
      stroke: "none"
    },
    d: "M493 511L494 512L493 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bec5bd",
      stroke: "none"
    },
    d: "M502 511L503 512L502 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46522",
      stroke: "none"
    },
    d: "M504 511L505 512L504 511z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtarr);
export default __webpack_public_path__ + "static/media/avtarr.985f211c73795e0decbaf60ff8b40985.svg";
export { ForwardRef as ReactComponent };